var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTyping = function SvgTyping(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 445,
    height: 394,
    viewBox: "0 0 445 394",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M231.27 380.653C336.261 380.653 421.373 295.441 421.373 190.326C421.373 85.212 336.261 0 231.27 0C126.278 0 41.1656 85.212 41.1656 190.326C41.1656 295.441 126.278 380.653 231.27 380.653Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.22 324.795C95.9742 343.596 99.3295 367.509 99.3295 367.509C99.3295 367.509 122.539 360.939 134.784 342.138C147.03 323.336 143.675 299.424 143.675 299.424C143.675 299.424 120.465 305.994 108.22 324.795Z",
    fill: "#3F3D56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2644 367.29C99.2644 367.29 98.9663 367.243 98.4176 367.131C97.98 367.043 97.3774 366.916 96.6417 366.741C90.0643 365.188 72.5775 359.94 61.1448 346.141C46.8357 328.862 47.4382 304.722 47.4382 304.722C47.4382 304.722 69.3174 308.282 83.7343 323.798C84.3591 324.465 84.9669 325.156 85.5578 325.872C98.0085 340.905 99.1692 361.134 99.2612 366.135C99.2739 366.884 99.2644 367.29 99.2644 367.29Z",
    fill: "#6C63FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4392 324.795C102.685 343.596 99.3295 367.509 99.3295 367.509C99.3295 367.509 76.1201 360.939 63.8745 342.138C51.6289 323.336 54.9842 299.424 54.9842 299.424C54.9842 299.424 78.1936 305.994 90.4392 324.795Z",
    stroke: "#3F3D56",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M99.2613 366.134C98.9378 366.525 98.6524 366.858 98.4177 367.131C97.8976 367.725 97.6026 368.036 97.6026 368.036C97.6026 368.036 97.2443 367.585 96.6417 366.741C93.334 362.124 82.6941 345.709 83.5155 326.748C83.5599 325.754 83.6329 324.771 83.7343 323.798C84.3591 324.465 84.9669 325.156 85.5579 325.872C98.0086 340.905 99.1693 361.134 99.2613 366.134Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.418 328.119C116.45 350.543 99.8237 368.037 99.8237 368.037C99.8237 368.037 84.7664 349.173 85.7343 326.748C86.7022 304.324 103.329 286.831 103.329 286.831C103.329 286.831 118.386 305.695 117.418 328.119Z",
    fill: "#6C63FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8237 367.402L103.479 287.745",
    stroke: "#3F3D56",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M222.5 394C345.383 394 445 385.858 445 375.815C445 365.772 345.383 357.631 222.5 357.631C99.6166 357.631 0 365.772 0 375.815C0 385.858 99.6166 394 222.5 394Z",
    fill: "#3F3D56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M257.862 157.639C252.315 159.514 247.289 163.901 246.153 169.652C245.627 172.317 245.95 175.088 245.507 177.769C244.479 183.986 239.604 188.734 235.108 193.145C230.612 197.555 225.969 202.68 225.641 208.973C225.282 215.864 230.274 222.32 229.41 229.166C228.406 237.12 220.015 242.274 217.941 250.018C216.556 255.188 218.253 260.758 221.046 265.323C226.367 274.023 235.463 279.929 245.149 283.096C254.835 286.262 265.151 286.928 275.34 287.035C287.746 287.165 301.216 286.099 310.538 277.901C315.862 273.177 319.206 266.612 319.899 259.523C320.784 250.027 316.826 240.216 319.556 231.079C321.275 225.329 325.584 220.077 324.941 214.11C324.312 208.275 319.222 204.14 315.73 199.426C312.47 195.025 310.492 189.828 308.553 184.704L301.919 167.172C300.615 163.726 299.183 160.101 296.276 157.839C290.835 153.605 282.087 154.437 275.724 155.31C269.822 156.12 263.538 155.72 257.862 157.639Z",
    fill: "#2F2E41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M259.94 208.708C259.94 208.708 262.88 218.277 240.824 229.318C218.768 240.36 243.03 252.137 243.03 252.137L268.762 258.025C268.762 258.025 295.23 254.345 298.171 249.928C301.111 245.512 306.258 230.791 304.787 228.582C303.687 227.01 302.458 225.533 301.111 224.166C301.111 224.166 283.466 221.222 284.202 213.125C284.937 205.028 259.94 208.708 259.94 208.708Z",
    fill: "#FFB9B9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M259.94 208.708C259.94 208.708 262.88 218.277 240.824 229.318C218.768 240.36 243.03 252.137 243.03 252.137L268.762 258.025C268.762 258.025 295.23 254.345 298.171 249.928C301.111 245.512 306.258 230.791 304.787 228.582C303.687 227.01 302.458 225.533 301.111 224.166C301.111 224.166 283.466 221.222 284.202 213.125C284.937 205.028 259.94 208.708 259.94 208.708Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M274.276 223.798C287.27 223.798 297.803 213.252 297.803 200.244C297.803 187.235 287.27 176.689 274.276 176.689C261.283 176.689 250.749 187.235 250.749 200.244C250.749 213.252 261.283 223.798 274.276 223.798Z",
    fill: "#FFB9B9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M271.703 249.928C271.703 249.928 243.369 247.854 242.832 228.281C242.832 228.281 232.737 227.11 229.796 230.054C226.855 232.999 217.297 235.207 217.297 242.568C217.297 249.928 233.472 272.011 233.472 272.011C233.472 272.011 242.294 301.453 238.618 306.606C234.942 311.758 234.207 325.008 234.207 325.008C234.207 325.008 270.968 322.064 276.849 325.008C282.731 327.952 306.258 327.952 307.728 325.008C309.199 322.064 306.258 285.26 306.258 285.26C306.258 285.26 312.875 276.427 311.404 266.122L329.049 245.512C329.049 245.512 322.432 225.638 312.139 225.638C312.139 225.638 298.17 221.958 297.803 223.798C297.435 225.638 304.787 246.248 271.703 249.928Z",
    fill: "#6C63FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M205.534 314.703C205.534 314.703 212.151 325.008 229.061 327.216C245.971 329.424 248.911 323.536 247.441 322.063C245.971 320.591 228.325 313.967 228.325 313.967L218.033 305.87L205.534 314.703Z",
    fill: "#FFB9B9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M326.109 305.87L306.993 316.911C306.993 316.911 281.996 315.439 291.554 322.8C301.111 330.16 318.756 327.216 318.756 327.216L335.666 319.119L326.109 305.87Z",
    fill: "#FFB9B9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M230.531 325.008C230.531 325.008 212.886 368.436 234.207 375.061C255.528 381.685 314.345 380.213 327.579 371.38C340.813 362.547 344.489 350.77 342.283 347.09C340.078 343.41 325.373 333.105 315.08 332.368C304.787 331.632 230.531 325.008 230.531 325.008Z",
    fill: "#2F2E41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M230.531 325.008C230.531 325.008 212.886 368.436 234.207 375.061C255.528 381.685 314.345 380.213 327.579 371.38C340.813 362.547 344.489 350.77 342.283 347.09C340.078 343.41 325.373 333.105 315.08 332.368C304.787 331.632 230.531 325.008 230.531 325.008Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M313.821 327.706C313.821 327.706 376.103 305.134 375.368 332.368C374.633 359.603 335.666 366.964 335.666 366.964L323.903 368.436L259.204 370.644C259.204 370.644 261.41 358.867 256.264 357.395C256.264 357.395 273.173 352.979 273.909 352.242C274.644 351.506 316.551 336.785 319.492 336.049C322.433 335.313 331.255 329.424 337.872 330.16C337.872 330.16 345.224 324.272 353.311 325.744L330.52 327.216L313.821 327.706Z",
    fill: "#2F2E41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M313.821 327.706C313.821 327.706 376.103 305.134 375.368 332.368C374.633 359.603 335.666 366.964 335.666 366.964L323.903 368.436L259.204 370.644C259.204 370.644 261.41 358.867 256.264 357.395C256.264 357.395 273.173 352.979 273.909 352.242C274.644 351.506 316.551 336.785 319.492 336.049C322.433 335.313 331.255 329.424 337.872 330.16C337.872 330.16 345.224 324.272 353.311 325.744L330.52 327.216L313.821 327.706Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M302.817 331.362L310.669 349.298L358.458 332.368L362.134 322.799L349.635 320.591L324.508 325.008L313.61 327.952L302.817 331.362Z",
    fill: "#2F2E41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M302.817 331.362L310.669 349.298L358.458 332.368L362.134 322.799L349.635 320.591L324.508 325.008L313.61 327.952L302.817 331.362Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M201.123 352.979C201.123 352.979 215.092 370.644 231.266 375.061C247.441 379.477 256.263 373.589 256.263 373.589L251.117 352.979L248.911 339.729L239.354 333.105L220.238 324.272L197.447 316.911C197.447 316.911 187.889 315.439 187.889 316.911C187.889 318.383 196.711 340.465 196.711 340.465L201.123 352.979Z",
    fill: "#2F2E41"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M218.032 362.547C218.032 362.547 220.973 383.893 224.649 385.366C228.325 386.838 239.354 383.893 242.294 382.421C245.235 380.949 255.232 374.157 255.232 374.157C255.232 374.157 220.238 361.075 218.032 362.547Z",
    fill: "#F2F2F2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M284.937 364.756L298.906 366.964L297.435 383.893L277.951 379.155L284.937 364.756Z",
    fill: "#FFB9B9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M293.689 369.467C293.689 369.467 287.142 377.269 293.759 381.685L298.17 385.366C298.17 385.366 312.875 388.31 314.345 389.782C315.816 391.254 321.697 387.574 321.697 387.574C321.697 387.574 322.432 365.492 321.697 364.02C320.962 362.547 312.139 361.075 311.404 362.547C310.669 364.02 301.847 366.228 296.7 364.756L293.689 369.467Z",
    fill: "#F2F2F2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M234.942 330.16C234.942 330.16 183.478 299.981 175.39 311.022C167.303 322.063 158.48 337.521 182.007 349.298C205.534 361.075 279.055 385.366 279.055 385.366C279.055 385.366 290.083 368.436 290.083 364.02C290.083 364.02 251.117 346.354 244.5 344.882C237.883 343.41 211.416 326.48 207.739 325.008C204.063 323.536 198.917 319.119 198.917 319.119L234.942 330.16Z",
    fill: "#2F2E41"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M220.238 238.887L217.297 241.096C217.297 241.096 210.68 258.025 209.945 267.594C209.21 277.163 200.388 306.606 201.123 310.286C201.858 313.967 202.593 316.911 207.004 320.591C207.004 320.591 212.886 307.342 223.179 309.55L235.678 263.914L220.238 238.887Z",
    fill: "#6C63FF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M323.168 238.887L329.049 245.512C329.049 245.512 332.725 254.345 332.725 256.553C332.725 258.761 340.078 291.148 340.813 292.621C341.548 294.093 344.489 312.495 340.813 316.911C337.137 321.327 330.52 324.272 330.52 324.272C330.52 324.272 334.931 308.814 320.962 308.078L322.433 302.189L309.199 258.025L323.168 238.887Z",
    fill: "#6C63FF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M221.708 289.565V328.337C221.709 330.785 222.671 333.135 224.387 334.879C226.103 336.623 228.436 337.621 230.881 337.657L311.87 338.858C314.301 338.894 316.649 337.977 318.414 336.302C320.178 334.627 321.218 332.328 321.311 329.896L322.801 291.12C322.849 289.878 322.648 288.639 322.21 287.476C321.773 286.313 321.107 285.249 320.253 284.347C319.399 283.445 318.373 282.724 317.236 282.225C316.099 281.726 314.874 281.459 313.632 281.441L231.154 280.244C229.92 280.227 228.695 280.454 227.55 280.915C226.405 281.375 225.362 282.059 224.483 282.926C223.604 283.793 222.907 284.827 222.43 285.967C221.954 287.106 221.708 288.329 221.708 289.565Z",
    fill: "#3F3D56"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M275.656 199.488C289.642 199.488 300.98 193.376 300.98 185.836C300.98 178.296 289.642 172.184 275.656 172.184C261.67 172.184 250.332 178.296 250.332 185.836C250.332 193.376 261.67 199.488 275.656 199.488Z",
    fill: "#2F2E41"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M271.335 315.807C274.584 315.807 277.217 313.17 277.217 309.918C277.217 306.666 274.584 304.03 271.335 304.03C268.087 304.03 265.454 306.666 265.454 309.918C265.454 313.17 268.087 315.807 271.335 315.807Z",
    fill: "#F2F2F2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M431.427 308.725V375.97C431.427 377.125 430.806 377.29 429.797 377.851C426.392 379.741 417.999 383.11 407.922 377.778C406.888 377.231 406.251 377.046 406.251 375.875V309.156C406.251 309.156 419.054 314.326 431.427 308.725Z",
    fill: "#2F2E41"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M418.839 311.356C425.791 311.356 431.427 310.158 431.427 308.68C431.427 307.202 425.791 306.004 418.839 306.004C411.887 306.004 406.251 307.202 406.251 308.68C406.251 310.158 411.887 311.356 418.839 311.356Z",
    fill: "#3F3D56",
    stroke: "#6C63FF",
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M430.281 336.931C430.437 336.931 430.563 336.805 430.563 336.649C430.563 336.493 430.437 336.366 430.281 336.366C430.125 336.366 429.998 336.493 429.998 336.649C429.998 336.805 430.125 336.931 430.281 336.931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M428.847 337.333C429.003 337.333 429.129 337.206 429.129 337.05C429.129 336.894 429.003 336.767 428.847 336.767C428.691 336.767 428.565 336.894 428.565 337.05C428.565 337.206 428.691 337.333 428.847 337.333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M427.076 337.898C427.232 337.898 427.358 337.772 427.358 337.615C427.358 337.459 427.232 337.333 427.076 337.333C426.92 337.333 426.793 337.459 426.793 337.615C426.793 337.772 426.92 337.898 427.076 337.898Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M423.899 338.583C424.055 338.583 424.182 338.457 424.182 338.301C424.182 338.144 424.055 338.018 423.899 338.018C423.744 338.018 423.617 338.144 423.617 338.301C423.617 338.457 423.744 338.583 423.899 338.583Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M420.551 338.989C420.707 338.989 420.833 338.863 420.833 338.706C420.833 338.55 420.707 338.424 420.551 338.424C420.395 338.424 420.268 338.55 420.268 338.706C420.268 338.863 420.395 338.989 420.551 338.989Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M417.083 339.149C417.239 339.149 417.365 339.022 417.365 338.866C417.365 338.71 417.239 338.583 417.083 338.583C416.927 338.583 416.8 338.71 416.8 338.866C416.8 339.022 416.927 339.149 417.083 339.149Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M412.105 338.464C412.261 338.464 412.387 338.337 412.387 338.181C412.387 338.025 412.261 337.898 412.105 337.898C411.949 337.898 411.823 338.025 411.823 338.181C411.823 338.337 411.949 338.464 412.105 338.464Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M413.754 338.866C413.91 338.866 414.037 338.739 414.037 338.583C414.037 338.427 413.91 338.301 413.754 338.301C413.598 338.301 413.472 338.427 413.472 338.583C413.472 338.739 413.598 338.866 413.754 338.866Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M409.024 337.898C409.18 337.898 409.306 337.772 409.306 337.615C409.306 337.459 409.18 337.333 409.024 337.333C408.868 337.333 408.741 337.459 408.741 337.615C408.741 337.772 408.868 337.898 409.024 337.898Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M410.508 338.181C410.664 338.181 410.79 338.054 410.79 337.898C410.79 337.742 410.664 337.615 410.508 337.615C410.352 337.615 410.225 337.742 410.225 337.898C410.225 338.054 410.352 338.181 410.508 338.181Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M407.398 337.333C407.554 337.333 407.68 337.206 407.68 337.05C407.68 336.894 407.554 336.767 407.398 336.767C407.242 336.767 407.115 336.894 407.115 337.05C407.115 337.206 407.242 337.333 407.398 337.333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M425.454 338.301C425.61 338.301 425.736 338.174 425.736 338.018C425.736 337.862 425.61 337.735 425.454 337.735C425.298 337.735 425.171 337.862 425.171 338.018C425.171 338.174 425.298 338.301 425.454 338.301Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M422.177 338.866C422.333 338.866 422.459 338.739 422.459 338.583C422.459 338.427 422.333 338.301 422.177 338.301C422.021 338.301 421.894 338.427 421.894 338.583C421.894 338.739 422.021 338.866 422.177 338.866Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M418.621 339.149C418.777 339.149 418.903 339.022 418.903 338.866C418.903 338.71 418.777 338.583 418.621 338.583C418.465 338.583 418.338 338.71 418.338 338.866C418.338 339.022 418.465 339.149 418.621 339.149Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M415.386 339.149C415.542 339.149 415.668 339.022 415.668 338.866C415.668 338.71 415.542 338.583 415.386 338.583C415.23 338.583 415.104 338.71 415.104 338.866C415.104 339.022 415.23 339.149 415.386 339.149Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M430.281 338.323C430.437 338.323 430.563 338.196 430.563 338.04C430.563 337.884 430.437 337.757 430.281 337.757C430.125 337.757 429.998 337.884 429.998 338.04C429.998 338.196 430.125 338.323 430.281 338.323Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M428.847 338.724C429.003 338.724 429.129 338.598 429.129 338.441C429.129 338.285 429.003 338.159 428.847 338.159C428.691 338.159 428.565 338.285 428.565 338.441C428.565 338.598 428.691 338.724 428.847 338.724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M427.076 339.29C427.232 339.29 427.358 339.163 427.358 339.007C427.358 338.851 427.232 338.724 427.076 338.724C426.92 338.724 426.793 338.851 426.793 339.007C426.793 339.163 426.92 339.29 427.076 339.29Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M423.899 339.975C424.055 339.975 424.182 339.848 424.182 339.692C424.182 339.536 424.055 339.409 423.899 339.409C423.744 339.409 423.617 339.536 423.617 339.692C423.617 339.848 423.744 339.975 423.899 339.975Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M420.551 340.381C420.707 340.381 420.833 340.254 420.833 340.098C420.833 339.942 420.707 339.815 420.551 339.815C420.395 339.815 420.268 339.942 420.268 340.098C420.268 340.254 420.395 340.381 420.551 340.381Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M417.083 340.54C417.239 340.54 417.365 340.414 417.365 340.258C417.365 340.101 417.239 339.975 417.083 339.975C416.927 339.975 416.8 340.101 416.8 340.258C416.8 340.414 416.927 340.54 417.083 340.54Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M412.105 339.855C412.261 339.855 412.387 339.729 412.387 339.572C412.387 339.416 412.261 339.29 412.105 339.29C411.949 339.29 411.823 339.416 411.823 339.572C411.823 339.729 411.949 339.855 412.105 339.855Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M413.754 340.258C413.91 340.258 414.037 340.131 414.037 339.975C414.037 339.819 413.91 339.692 413.754 339.692C413.598 339.692 413.472 339.819 413.472 339.975C413.472 340.131 413.598 340.258 413.754 340.258Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M409.024 339.29C409.18 339.29 409.306 339.163 409.306 339.007C409.306 338.851 409.18 338.724 409.024 338.724C408.868 338.724 408.741 338.851 408.741 339.007C408.741 339.163 408.868 339.29 409.024 339.29Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M410.508 339.572C410.664 339.572 410.79 339.446 410.79 339.29C410.79 339.133 410.664 339.007 410.508 339.007C410.352 339.007 410.225 339.133 410.225 339.29C410.225 339.446 410.352 339.572 410.508 339.572Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M407.398 338.724C407.554 338.724 407.68 338.598 407.68 338.441C407.68 338.285 407.554 338.159 407.398 338.159C407.242 338.159 407.115 338.285 407.115 338.441C407.115 338.598 407.242 338.724 407.398 338.724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M425.454 339.692C425.61 339.692 425.736 339.565 425.736 339.409C425.736 339.253 425.61 339.126 425.454 339.126C425.298 339.126 425.171 339.253 425.171 339.409C425.171 339.565 425.298 339.692 425.454 339.692Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M422.177 340.258C422.333 340.258 422.459 340.131 422.459 339.975C422.459 339.819 422.333 339.692 422.177 339.692C422.021 339.692 421.894 339.819 421.894 339.975C421.894 340.131 422.021 340.258 422.177 340.258Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M418.621 340.54C418.777 340.54 418.903 340.414 418.903 340.258C418.903 340.101 418.777 339.975 418.621 339.975C418.465 339.975 418.338 340.101 418.338 340.258C418.338 340.414 418.465 340.54 418.621 340.54Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M415.386 340.54C415.542 340.54 415.668 340.414 415.668 340.258C415.668 340.101 415.542 339.975 415.386 339.975C415.23 339.975 415.104 340.101 415.104 340.258C415.104 340.414 415.23 340.54 415.386 340.54Z",
    fill: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M430.281 339.714C430.437 339.714 430.563 339.588 430.563 339.432C430.563 339.275 430.437 339.149 430.281 339.149C430.125 339.149 429.998 339.275 429.998 339.432C429.998 339.588 430.125 339.714 430.281 339.714Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M428.847 340.116C429.003 340.116 429.129 339.989 429.129 339.833C429.129 339.677 429.003 339.55 428.847 339.55C428.691 339.55 428.565 339.677 428.565 339.833C428.565 339.989 428.691 340.116 428.847 340.116Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M427.076 340.681C427.232 340.681 427.358 340.555 427.358 340.398C427.358 340.242 427.232 340.116 427.076 340.116C426.92 340.116 426.793 340.242 426.793 340.398C426.793 340.555 426.92 340.681 427.076 340.681Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M423.899 341.366C424.055 341.366 424.182 341.24 424.182 341.083C424.182 340.927 424.055 340.801 423.899 340.801C423.744 340.801 423.617 340.927 423.617 341.083C423.617 341.24 423.744 341.366 423.899 341.366Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M420.551 341.772C420.707 341.772 420.833 341.646 420.833 341.489C420.833 341.333 420.707 341.207 420.551 341.207C420.395 341.207 420.268 341.333 420.268 341.489C420.268 341.646 420.395 341.772 420.551 341.772Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M417.083 341.932C417.239 341.932 417.365 341.805 417.365 341.649C417.365 341.493 417.239 341.366 417.083 341.366C416.927 341.366 416.8 341.493 416.8 341.649C416.8 341.805 416.927 341.932 417.083 341.932Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M412.105 341.247C412.261 341.247 412.387 341.12 412.387 340.964C412.387 340.808 412.261 340.681 412.105 340.681C411.949 340.681 411.823 340.808 411.823 340.964C411.823 341.12 411.949 341.247 412.105 341.247Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M413.754 341.649C413.91 341.649 414.037 341.522 414.037 341.366C414.037 341.21 413.91 341.083 413.754 341.083C413.598 341.083 413.472 341.21 413.472 341.366C413.472 341.522 413.598 341.649 413.754 341.649Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M409.024 340.681C409.18 340.681 409.306 340.555 409.306 340.398C409.306 340.242 409.18 340.116 409.024 340.116C408.868 340.116 408.741 340.242 408.741 340.398C408.741 340.555 408.868 340.681 409.024 340.681Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M410.508 340.964C410.664 340.964 410.79 340.837 410.79 340.681C410.79 340.525 410.664 340.398 410.508 340.398C410.352 340.398 410.225 340.525 410.225 340.681C410.225 340.837 410.352 340.964 410.508 340.964Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M407.398 340.116C407.554 340.116 407.68 339.989 407.68 339.833C407.68 339.677 407.554 339.55 407.398 339.55C407.242 339.55 407.115 339.677 407.115 339.833C407.115 339.989 407.242 340.116 407.398 340.116Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M425.454 341.083C425.61 341.083 425.736 340.957 425.736 340.801C425.736 340.645 425.61 340.518 425.454 340.518C425.298 340.518 425.171 340.645 425.171 340.801C425.171 340.957 425.298 341.083 425.454 341.083Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M422.177 341.649C422.333 341.649 422.459 341.522 422.459 341.366C422.459 341.21 422.333 341.083 422.177 341.083C422.021 341.083 421.894 341.21 421.894 341.366C421.894 341.522 422.021 341.649 422.177 341.649Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M418.621 341.932C418.777 341.932 418.903 341.805 418.903 341.649C418.903 341.493 418.777 341.366 418.621 341.366C418.465 341.366 418.338 341.493 418.338 341.649C418.338 341.805 418.465 341.932 418.621 341.932Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M415.386 341.932C415.542 341.932 415.668 341.805 415.668 341.649C415.668 341.493 415.542 341.366 415.386 341.366C415.23 341.366 415.104 341.493 415.104 341.649C415.104 341.805 415.23 341.932 415.386 341.932Z",
    fill: "black"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M430.281 341.106C430.437 341.106 430.563 340.979 430.563 340.823C430.563 340.667 430.437 340.54 430.281 340.54C430.125 340.54 429.998 340.667 429.998 340.823C429.998 340.979 430.125 341.106 430.281 341.106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M428.847 341.507C429.003 341.507 429.129 341.38 429.129 341.224C429.129 341.068 429.003 340.942 428.847 340.942C428.691 340.942 428.565 341.068 428.565 341.224C428.565 341.38 428.691 341.507 428.847 341.507Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M427.076 342.073C427.232 342.073 427.358 341.946 427.358 341.79C427.358 341.634 427.232 341.507 427.076 341.507C426.92 341.507 426.793 341.634 426.793 341.79C426.793 341.946 426.92 342.073 427.076 342.073Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M423.899 342.758C424.055 342.758 424.182 342.631 424.182 342.475C424.182 342.319 424.055 342.192 423.899 342.192C423.744 342.192 423.617 342.319 423.617 342.475C423.617 342.631 423.744 342.758 423.899 342.758Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M420.551 343.164C420.707 343.164 420.833 343.037 420.833 342.881C420.833 342.725 420.707 342.598 420.551 342.598C420.395 342.598 420.268 342.725 420.268 342.881C420.268 343.037 420.395 343.164 420.551 343.164Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M417.083 343.323C417.239 343.323 417.365 343.197 417.365 343.04C417.365 342.884 417.239 342.758 417.083 342.758C416.927 342.758 416.8 342.884 416.8 343.04C416.8 343.197 416.927 343.323 417.083 343.323Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M412.105 342.638C412.261 342.638 412.387 342.511 412.387 342.355C412.387 342.199 412.261 342.073 412.105 342.073C411.949 342.073 411.823 342.199 411.823 342.355C411.823 342.511 411.949 342.638 412.105 342.638Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M413.754 343.04C413.91 343.04 414.037 342.914 414.037 342.758C414.037 342.601 413.91 342.475 413.754 342.475C413.598 342.475 413.472 342.601 413.472 342.758C413.472 342.914 413.598 343.04 413.754 343.04Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M409.024 342.073C409.18 342.073 409.306 341.946 409.306 341.79C409.306 341.634 409.18 341.507 409.024 341.507C408.868 341.507 408.741 341.634 408.741 341.79C408.741 341.946 408.868 342.073 409.024 342.073Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M410.508 342.355C410.664 342.355 410.79 342.229 410.79 342.073C410.79 341.916 410.664 341.79 410.508 341.79C410.352 341.79 410.225 341.916 410.225 342.073C410.225 342.229 410.352 342.355 410.508 342.355Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M407.398 341.507C407.554 341.507 407.68 341.38 407.68 341.224C407.68 341.068 407.554 340.942 407.398 340.942C407.242 340.942 407.115 341.068 407.115 341.224C407.115 341.38 407.242 341.507 407.398 341.507Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M425.454 342.475C425.61 342.475 425.736 342.348 425.736 342.192C425.736 342.036 425.61 341.909 425.454 341.909C425.298 341.909 425.171 342.036 425.171 342.192C425.171 342.348 425.298 342.475 425.454 342.475Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M422.177 343.04C422.333 343.04 422.459 342.914 422.459 342.758C422.459 342.601 422.333 342.475 422.177 342.475C422.021 342.475 421.894 342.601 421.894 342.758C421.894 342.914 422.021 343.04 422.177 343.04Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M418.621 343.323C418.777 343.323 418.903 343.197 418.903 343.04C418.903 342.884 418.777 342.758 418.621 342.758C418.465 342.758 418.338 342.884 418.338 343.04C418.338 343.197 418.465 343.323 418.621 343.323Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M415.386 343.323C415.542 343.323 415.668 343.197 415.668 343.04C415.668 342.884 415.542 342.758 415.386 342.758C415.23 342.758 415.104 342.884 415.104 343.04C415.104 343.197 415.23 343.323 415.386 343.323Z",
    fill: "black"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M430.281 342.497C430.437 342.497 430.563 342.371 430.563 342.214C430.563 342.058 430.437 341.932 430.281 341.932C430.125 341.932 429.998 342.058 429.998 342.214C429.998 342.371 430.125 342.497 430.281 342.497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M428.847 342.898C429.003 342.898 429.129 342.772 429.129 342.616C429.129 342.46 429.003 342.333 428.847 342.333C428.691 342.333 428.565 342.46 428.565 342.616C428.565 342.772 428.691 342.898 428.847 342.898Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M427.076 343.464C427.232 343.464 427.358 343.337 427.358 343.181C427.358 343.025 427.232 342.898 427.076 342.898C426.92 342.898 426.793 343.025 426.793 343.181C426.793 343.337 426.92 343.464 427.076 343.464Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M423.899 344.149C424.055 344.149 424.182 344.022 424.182 343.866C424.182 343.71 424.055 343.584 423.899 343.584C423.744 343.584 423.617 343.71 423.617 343.866C423.617 344.022 423.744 344.149 423.899 344.149Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M420.551 344.555C420.707 344.555 420.833 344.428 420.833 344.272C420.833 344.116 420.707 343.99 420.551 343.99C420.395 343.99 420.268 344.116 420.268 344.272C420.268 344.428 420.395 344.555 420.551 344.555Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M417.083 344.715C417.239 344.715 417.365 344.588 417.365 344.432C417.365 344.276 417.239 344.149 417.083 344.149C416.927 344.149 416.8 344.276 416.8 344.432C416.8 344.588 416.927 344.715 417.083 344.715Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M412.105 344.03C412.261 344.03 412.387 343.903 412.387 343.747C412.387 343.591 412.261 343.464 412.105 343.464C411.949 343.464 411.823 343.591 411.823 343.747C411.823 343.903 411.949 344.03 412.105 344.03Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M413.754 344.432C413.91 344.432 414.037 344.305 414.037 344.149C414.037 343.993 413.91 343.866 413.754 343.866C413.598 343.866 413.472 343.993 413.472 344.149C413.472 344.305 413.598 344.432 413.754 344.432Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M409.024 343.464C409.18 343.464 409.306 343.337 409.306 343.181C409.306 343.025 409.18 342.898 409.024 342.898C408.868 342.898 408.741 343.025 408.741 343.181C408.741 343.337 408.868 343.464 409.024 343.464Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M410.508 343.747C410.664 343.747 410.79 343.62 410.79 343.464C410.79 343.308 410.664 343.181 410.508 343.181C410.352 343.181 410.225 343.308 410.225 343.464C410.225 343.62 410.352 343.747 410.508 343.747Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M407.398 342.898C407.554 342.898 407.68 342.772 407.68 342.616C407.68 342.46 407.554 342.333 407.398 342.333C407.242 342.333 407.115 342.46 407.115 342.616C407.115 342.772 407.242 342.898 407.398 342.898Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M425.454 343.866C425.61 343.866 425.736 343.74 425.736 343.584C425.736 343.427 425.61 343.301 425.454 343.301C425.298 343.301 425.171 343.427 425.171 343.584C425.171 343.74 425.298 343.866 425.454 343.866Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M422.177 344.432C422.333 344.432 422.459 344.305 422.459 344.149C422.459 343.993 422.333 343.866 422.177 343.866C422.021 343.866 421.894 343.993 421.894 344.149C421.894 344.305 422.021 344.432 422.177 344.432Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M418.621 344.715C418.777 344.715 418.903 344.588 418.903 344.432C418.903 344.276 418.777 344.149 418.621 344.149C418.465 344.149 418.338 344.276 418.338 344.432C418.338 344.588 418.465 344.715 418.621 344.715Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M415.386 344.715C415.542 344.715 415.668 344.588 415.668 344.432C415.668 344.276 415.542 344.149 415.386 344.149C415.23 344.149 415.104 344.276 415.104 344.432C415.104 344.588 415.23 344.715 415.386 344.715Z",
    fill: "black"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M430.281 343.889C430.437 343.889 430.563 343.762 430.563 343.606C430.563 343.45 430.437 343.323 430.281 343.323C430.125 343.323 429.998 343.45 429.998 343.606C429.998 343.762 430.125 343.889 430.281 343.889Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M428.847 344.29C429.003 344.29 429.129 344.163 429.129 344.007C429.129 343.851 429.003 343.724 428.847 343.724C428.691 343.724 428.565 343.851 428.565 344.007C428.565 344.163 428.691 344.29 428.847 344.29Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M427.076 344.855C427.232 344.855 427.358 344.729 427.358 344.573C427.358 344.417 427.232 344.29 427.076 344.29C426.92 344.29 426.793 344.417 426.793 344.573C426.793 344.729 426.92 344.855 427.076 344.855Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M423.899 345.541C424.055 345.541 424.182 345.414 424.182 345.258C424.182 345.102 424.055 344.975 423.899 344.975C423.744 344.975 423.617 345.102 423.617 345.258C423.617 345.414 423.744 345.541 423.899 345.541Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M420.551 345.946C420.707 345.946 420.833 345.82 420.833 345.664C420.833 345.508 420.707 345.381 420.551 345.381C420.395 345.381 420.268 345.508 420.268 345.664C420.268 345.82 420.395 345.946 420.551 345.946Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M417.083 346.106C417.239 346.106 417.365 345.979 417.365 345.823C417.365 345.667 417.239 345.541 417.083 345.541C416.927 345.541 416.8 345.667 416.8 345.823C416.8 345.979 416.927 346.106 417.083 346.106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M412.105 345.421C412.261 345.421 412.387 345.294 412.387 345.138C412.387 344.982 412.261 344.855 412.105 344.855C411.949 344.855 411.823 344.982 411.823 345.138C411.823 345.294 411.949 345.421 412.105 345.421Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M413.754 345.823C413.91 345.823 414.037 345.697 414.037 345.541C414.037 345.384 413.91 345.258 413.754 345.258C413.598 345.258 413.472 345.384 413.472 345.541C413.472 345.697 413.598 345.823 413.754 345.823Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M409.024 344.855C409.18 344.855 409.306 344.729 409.306 344.573C409.306 344.417 409.18 344.29 409.024 344.29C408.868 344.29 408.741 344.417 408.741 344.573C408.741 344.729 408.868 344.855 409.024 344.855Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M410.508 345.138C410.664 345.138 410.79 345.012 410.79 344.855C410.79 344.699 410.664 344.573 410.508 344.573C410.352 344.573 410.225 344.699 410.225 344.855C410.225 345.012 410.352 345.138 410.508 345.138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M407.398 344.29C407.554 344.29 407.68 344.163 407.68 344.007C407.68 343.851 407.554 343.724 407.398 343.724C407.242 343.724 407.115 343.851 407.115 344.007C407.115 344.163 407.242 344.29 407.398 344.29Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M425.454 345.258C425.61 345.258 425.736 345.131 425.736 344.975C425.736 344.819 425.61 344.692 425.454 344.692C425.298 344.692 425.171 344.819 425.171 344.975C425.171 345.131 425.298 345.258 425.454 345.258Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M422.177 345.823C422.333 345.823 422.459 345.697 422.459 345.541C422.459 345.384 422.333 345.258 422.177 345.258C422.021 345.258 421.894 345.384 421.894 345.541C421.894 345.697 422.021 345.823 422.177 345.823Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M418.621 346.106C418.777 346.106 418.903 345.979 418.903 345.823C418.903 345.667 418.777 345.541 418.621 345.541C418.465 345.541 418.338 345.667 418.338 345.823C418.338 345.979 418.465 346.106 418.621 346.106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M415.386 346.106C415.542 346.106 415.668 345.979 415.668 345.823C415.668 345.667 415.542 345.541 415.386 345.541C415.23 345.541 415.104 345.667 415.104 345.823C415.104 345.979 415.23 346.106 415.386 346.106Z",
    fill: "black"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M430.281 345.28C430.437 345.28 430.563 345.154 430.563 344.997C430.563 344.841 430.437 344.715 430.281 344.715C430.125 344.715 429.998 344.841 429.998 344.997C429.998 345.154 430.125 345.28 430.281 345.28Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M428.847 345.681C429.003 345.681 429.129 345.555 429.129 345.399C429.129 345.242 429.003 345.116 428.847 345.116C428.691 345.116 428.565 345.242 428.565 345.399C428.565 345.555 428.691 345.681 428.847 345.681Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M427.076 346.247C427.232 346.247 427.358 346.12 427.358 345.964C427.358 345.808 427.232 345.681 427.076 345.681C426.92 345.681 426.793 345.808 426.793 345.964C426.793 346.12 426.92 346.247 427.076 346.247Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M423.899 346.932C424.055 346.932 424.182 346.805 424.182 346.649C424.182 346.493 424.055 346.366 423.899 346.366C423.744 346.366 423.617 346.493 423.617 346.649C423.617 346.805 423.744 346.932 423.899 346.932Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M420.551 347.338C420.707 347.338 420.833 347.211 420.833 347.055C420.833 346.899 420.707 346.772 420.551 346.772C420.395 346.772 420.268 346.899 420.268 347.055C420.268 347.211 420.395 347.338 420.551 347.338Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M417.083 347.498C417.239 347.498 417.365 347.371 417.365 347.215C417.365 347.059 417.239 346.932 417.083 346.932C416.927 346.932 416.8 347.059 416.8 347.215C416.8 347.371 416.927 347.498 417.083 347.498Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M412.105 346.812C412.261 346.812 412.387 346.686 412.387 346.53C412.387 346.374 412.261 346.247 412.105 346.247C411.949 346.247 411.823 346.374 411.823 346.53C411.823 346.686 411.949 346.812 412.105 346.812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M413.754 347.215C413.91 347.215 414.037 347.088 414.037 346.932C414.037 346.776 413.91 346.649 413.754 346.649C413.598 346.649 413.472 346.776 413.472 346.932C413.472 347.088 413.598 347.215 413.754 347.215Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M409.024 346.247C409.18 346.247 409.306 346.12 409.306 345.964C409.306 345.808 409.18 345.681 409.024 345.681C408.868 345.681 408.741 345.808 408.741 345.964C408.741 346.12 408.868 346.247 409.024 346.247Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M410.508 346.53C410.664 346.53 410.79 346.403 410.79 346.247C410.79 346.091 410.664 345.964 410.508 345.964C410.352 345.964 410.225 346.091 410.225 346.247C410.225 346.403 410.352 346.53 410.508 346.53Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M407.398 345.681C407.554 345.681 407.68 345.555 407.68 345.399C407.68 345.242 407.554 345.116 407.398 345.116C407.242 345.116 407.115 345.242 407.115 345.399C407.115 345.555 407.242 345.681 407.398 345.681Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M425.454 346.649C425.61 346.649 425.736 346.523 425.736 346.366C425.736 346.21 425.61 346.084 425.454 346.084C425.298 346.084 425.171 346.21 425.171 346.366C425.171 346.523 425.298 346.649 425.454 346.649Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M422.177 347.215C422.333 347.215 422.459 347.088 422.459 346.932C422.459 346.776 422.333 346.649 422.177 346.649C422.021 346.649 421.894 346.776 421.894 346.932C421.894 347.088 422.021 347.215 422.177 347.215Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M418.621 347.498C418.777 347.498 418.903 347.371 418.903 347.215C418.903 347.059 418.777 346.932 418.621 346.932C418.465 346.932 418.338 347.059 418.338 347.215C418.338 347.371 418.465 347.498 418.621 347.498Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M415.386 347.498C415.542 347.498 415.668 347.371 415.668 347.215C415.668 347.059 415.542 346.932 415.386 346.932C415.23 346.932 415.104 347.059 415.104 347.215C415.104 347.371 415.23 347.498 415.386 347.498Z",
    fill: "black"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M430.281 346.672C430.437 346.672 430.563 346.545 430.563 346.389C430.563 346.233 430.437 346.106 430.281 346.106C430.125 346.106 429.998 346.233 429.998 346.389C429.998 346.545 430.125 346.672 430.281 346.672Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M428.847 347.073C429.003 347.073 429.129 346.946 429.129 346.79C429.129 346.634 429.003 346.507 428.847 346.507C428.691 346.507 428.565 346.634 428.565 346.79C428.565 346.946 428.691 347.073 428.847 347.073Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M427.076 347.638C427.232 347.638 427.358 347.512 427.358 347.356C427.358 347.199 427.232 347.073 427.076 347.073C426.92 347.073 426.793 347.199 426.793 347.356C426.793 347.512 426.92 347.638 427.076 347.638Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M423.899 348.323C424.055 348.323 424.182 348.197 424.182 348.041C424.182 347.885 424.055 347.758 423.899 347.758C423.744 347.758 423.617 347.885 423.617 348.041C423.617 348.197 423.744 348.323 423.899 348.323Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M420.551 348.729C420.707 348.729 420.833 348.603 420.833 348.447C420.833 348.29 420.707 348.164 420.551 348.164C420.395 348.164 420.268 348.29 420.268 348.447C420.268 348.603 420.395 348.729 420.551 348.729Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M417.083 348.889C417.239 348.889 417.365 348.762 417.365 348.606C417.365 348.45 417.239 348.323 417.083 348.323C416.927 348.323 416.8 348.45 416.8 348.606C416.8 348.762 416.927 348.889 417.083 348.889Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M412.105 348.204C412.261 348.204 412.387 348.077 412.387 347.921C412.387 347.765 412.261 347.638 412.105 347.638C411.949 347.638 411.823 347.765 411.823 347.921C411.823 348.077 411.949 348.204 412.105 348.204Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M413.754 348.606C413.91 348.606 414.037 348.48 414.037 348.323C414.037 348.167 413.91 348.041 413.754 348.041C413.598 348.041 413.472 348.167 413.472 348.323C413.472 348.48 413.598 348.606 413.754 348.606Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M409.024 347.638C409.18 347.638 409.306 347.512 409.306 347.356C409.306 347.199 409.18 347.073 409.024 347.073C408.868 347.073 408.741 347.199 408.741 347.356C408.741 347.512 408.868 347.638 409.024 347.638Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M410.508 347.921C410.664 347.921 410.79 347.795 410.79 347.638C410.79 347.482 410.664 347.356 410.508 347.356C410.352 347.356 410.225 347.482 410.225 347.638C410.225 347.795 410.352 347.921 410.508 347.921Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M407.398 347.073C407.554 347.073 407.68 346.946 407.68 346.79C407.68 346.634 407.554 346.507 407.398 346.507C407.242 346.507 407.115 346.634 407.115 346.79C407.115 346.946 407.242 347.073 407.398 347.073Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M425.454 348.041C425.61 348.041 425.736 347.914 425.736 347.758C425.736 347.602 425.61 347.475 425.454 347.475C425.298 347.475 425.171 347.602 425.171 347.758C425.171 347.914 425.298 348.041 425.454 348.041Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M422.177 348.606C422.333 348.606 422.459 348.48 422.459 348.323C422.459 348.167 422.333 348.041 422.177 348.041C422.021 348.041 421.894 348.167 421.894 348.323C421.894 348.48 422.021 348.606 422.177 348.606Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M418.621 348.889C418.777 348.889 418.903 348.762 418.903 348.606C418.903 348.45 418.777 348.323 418.621 348.323C418.465 348.323 418.338 348.45 418.338 348.606C418.338 348.762 418.465 348.889 418.621 348.889Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M415.386 348.889C415.542 348.889 415.668 348.762 415.668 348.606C415.668 348.45 415.542 348.323 415.386 348.323C415.23 348.323 415.104 348.45 415.104 348.606C415.104 348.762 415.23 348.889 415.386 348.889Z",
    fill: "black"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M430.281 348.063C430.437 348.063 430.563 347.936 430.563 347.78C430.563 347.624 430.437 347.498 430.281 347.498C430.125 347.498 429.998 347.624 429.998 347.78C429.998 347.936 430.125 348.063 430.281 348.063Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M428.847 348.464C429.003 348.464 429.129 348.338 429.129 348.182C429.129 348.025 429.003 347.899 428.847 347.899C428.691 347.899 428.565 348.025 428.565 348.182C428.565 348.338 428.691 348.464 428.847 348.464Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M427.076 349.03C427.232 349.03 427.358 348.903 427.358 348.747C427.358 348.591 427.232 348.464 427.076 348.464C426.92 348.464 426.793 348.591 426.793 348.747C426.793 348.903 426.92 349.03 427.076 349.03Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M423.899 349.715C424.055 349.715 424.182 349.588 424.182 349.432C424.182 349.276 424.055 349.149 423.899 349.149C423.744 349.149 423.617 349.276 423.617 349.432C423.617 349.588 423.744 349.715 423.899 349.715Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M420.551 350.121C420.707 350.121 420.833 349.994 420.833 349.838C420.833 349.682 420.707 349.555 420.551 349.555C420.395 349.555 420.268 349.682 420.268 349.838C420.268 349.994 420.395 350.121 420.551 350.121Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M417.083 350.28C417.239 350.28 417.365 350.154 417.365 349.998C417.365 349.841 417.239 349.715 417.083 349.715C416.927 349.715 416.8 349.841 416.8 349.998C416.8 350.154 416.927 350.28 417.083 350.28Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M412.105 349.595C412.261 349.595 412.387 349.469 412.387 349.313C412.387 349.156 412.261 349.03 412.105 349.03C411.949 349.03 411.823 349.156 411.823 349.313C411.823 349.469 411.949 349.595 412.105 349.595Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M413.754 349.998C413.91 349.998 414.037 349.871 414.037 349.715C414.037 349.559 413.91 349.432 413.754 349.432C413.598 349.432 413.472 349.559 413.472 349.715C413.472 349.871 413.598 349.998 413.754 349.998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M409.024 349.03C409.18 349.03 409.306 348.903 409.306 348.747C409.306 348.591 409.18 348.464 409.024 348.464C408.868 348.464 408.741 348.591 408.741 348.747C408.741 348.903 408.868 349.03 409.024 349.03Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M410.508 349.313C410.664 349.313 410.79 349.186 410.79 349.03C410.79 348.874 410.664 348.747 410.508 348.747C410.352 348.747 410.225 348.874 410.225 349.03C410.225 349.186 410.352 349.313 410.508 349.313Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M407.398 348.464C407.554 348.464 407.68 348.338 407.68 348.182C407.68 348.025 407.554 347.899 407.398 347.899C407.242 347.899 407.115 348.025 407.115 348.182C407.115 348.338 407.242 348.464 407.398 348.464Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M425.454 349.432C425.61 349.432 425.736 349.306 425.736 349.149C425.736 348.993 425.61 348.867 425.454 348.867C425.298 348.867 425.171 348.993 425.171 349.149C425.171 349.306 425.298 349.432 425.454 349.432Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M422.177 349.998C422.333 349.998 422.459 349.871 422.459 349.715C422.459 349.559 422.333 349.432 422.177 349.432C422.021 349.432 421.894 349.559 421.894 349.715C421.894 349.871 422.021 349.998 422.177 349.998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M418.621 350.28C418.777 350.28 418.903 350.154 418.903 349.998C418.903 349.841 418.777 349.715 418.621 349.715C418.465 349.715 418.338 349.841 418.338 349.998C418.338 350.154 418.465 350.28 418.621 350.28Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M415.386 350.28C415.542 350.28 415.668 350.154 415.668 349.998C415.668 349.841 415.542 349.715 415.386 349.715C415.23 349.715 415.104 349.841 415.104 349.998C415.104 350.154 415.23 350.28 415.386 350.28Z",
    fill: "black"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M430.281 349.454C430.437 349.454 430.563 349.328 430.563 349.172C430.563 349.016 430.437 348.889 430.281 348.889C430.125 348.889 429.998 349.016 429.998 349.172C429.998 349.328 430.125 349.454 430.281 349.454Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M428.847 349.856C429.003 349.856 429.129 349.729 429.129 349.573C429.129 349.417 429.003 349.29 428.847 349.29C428.691 349.29 428.565 349.417 428.565 349.573C428.565 349.729 428.691 349.856 428.847 349.856Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M427.076 350.421C427.232 350.421 427.358 350.295 427.358 350.138C427.358 349.982 427.232 349.856 427.076 349.856C426.92 349.856 426.793 349.982 426.793 350.138C426.793 350.295 426.92 350.421 427.076 350.421Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M423.899 351.106C424.055 351.106 424.182 350.98 424.182 350.824C424.182 350.667 424.055 350.541 423.899 350.541C423.744 350.541 423.617 350.667 423.617 350.824C423.617 350.98 423.744 351.106 423.899 351.106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M420.551 351.512C420.707 351.512 420.833 351.386 420.833 351.23C420.833 351.073 420.707 350.947 420.551 350.947C420.395 350.947 420.268 351.073 420.268 351.23C420.268 351.386 420.395 351.512 420.551 351.512Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M417.083 351.672C417.239 351.672 417.365 351.545 417.365 351.389C417.365 351.233 417.239 351.106 417.083 351.106C416.927 351.106 416.8 351.233 416.8 351.389C416.8 351.545 416.927 351.672 417.083 351.672Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M412.105 350.987C412.261 350.987 412.387 350.86 412.387 350.704C412.387 350.548 412.261 350.421 412.105 350.421C411.949 350.421 411.823 350.548 411.823 350.704C411.823 350.86 411.949 350.987 412.105 350.987Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M413.754 351.389C413.91 351.389 414.037 351.263 414.037 351.106C414.037 350.95 413.91 350.824 413.754 350.824C413.598 350.824 413.472 350.95 413.472 351.106C413.472 351.263 413.598 351.389 413.754 351.389Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M409.024 350.421C409.18 350.421 409.306 350.295 409.306 350.138C409.306 349.982 409.18 349.856 409.024 349.856C408.868 349.856 408.741 349.982 408.741 350.138C408.741 350.295 408.868 350.421 409.024 350.421Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M410.508 350.704C410.664 350.704 410.79 350.577 410.79 350.421C410.79 350.265 410.664 350.138 410.508 350.138C410.352 350.138 410.225 350.265 410.225 350.421C410.225 350.577 410.352 350.704 410.508 350.704Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M407.398 349.856C407.554 349.856 407.68 349.729 407.68 349.573C407.68 349.417 407.554 349.29 407.398 349.29C407.242 349.29 407.115 349.417 407.115 349.573C407.115 349.729 407.242 349.856 407.398 349.856Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M425.454 350.824C425.61 350.824 425.736 350.697 425.736 350.541C425.736 350.385 425.61 350.258 425.454 350.258C425.298 350.258 425.171 350.385 425.171 350.541C425.171 350.697 425.298 350.824 425.454 350.824Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M422.177 351.389C422.333 351.389 422.459 351.263 422.459 351.106C422.459 350.95 422.333 350.824 422.177 350.824C422.021 350.824 421.894 350.95 421.894 351.106C421.894 351.263 422.021 351.389 422.177 351.389Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M418.621 351.672C418.777 351.672 418.903 351.545 418.903 351.389C418.903 351.233 418.777 351.106 418.621 351.106C418.465 351.106 418.338 351.233 418.338 351.389C418.338 351.545 418.465 351.672 418.621 351.672Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M415.386 351.672C415.542 351.672 415.668 351.545 415.668 351.389C415.668 351.233 415.542 351.106 415.386 351.106C415.23 351.106 415.104 351.233 415.104 351.389C415.104 351.545 415.23 351.672 415.386 351.672Z",
    fill: "black"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M430.281 350.846C430.437 350.846 430.563 350.719 430.563 350.563C430.563 350.407 430.437 350.28 430.281 350.28C430.125 350.28 429.998 350.407 429.998 350.563C429.998 350.719 430.125 350.846 430.281 350.846Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M428.847 351.247C429.003 351.247 429.129 351.121 429.129 350.964C429.129 350.808 429.003 350.682 428.847 350.682C428.691 350.682 428.565 350.808 428.565 350.964C428.565 351.121 428.691 351.247 428.847 351.247Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M427.076 351.813C427.232 351.813 427.358 351.686 427.358 351.53C427.358 351.374 427.232 351.247 427.076 351.247C426.92 351.247 426.793 351.374 426.793 351.53C426.793 351.686 426.92 351.813 427.076 351.813Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M423.899 352.498C424.055 352.498 424.182 352.371 424.182 352.215C424.182 352.059 424.055 351.932 423.899 351.932C423.744 351.932 423.617 352.059 423.617 352.215C423.617 352.371 423.744 352.498 423.899 352.498Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M420.551 352.904C420.707 352.904 420.833 352.777 420.833 352.621C420.833 352.465 420.707 352.338 420.551 352.338C420.395 352.338 420.268 352.465 420.268 352.621C420.268 352.777 420.395 352.904 420.551 352.904Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M417.083 353.063C417.239 353.063 417.365 352.937 417.365 352.781C417.365 352.624 417.239 352.498 417.083 352.498C416.927 352.498 416.8 352.624 416.8 352.781C416.8 352.937 416.927 353.063 417.083 353.063Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M412.105 352.378C412.261 352.378 412.387 352.252 412.387 352.095C412.387 351.939 412.261 351.813 412.105 351.813C411.949 351.813 411.823 351.939 411.823 352.095C411.823 352.252 411.949 352.378 412.105 352.378Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M413.754 352.781C413.91 352.781 414.037 352.654 414.037 352.498C414.037 352.342 413.91 352.215 413.754 352.215C413.598 352.215 413.472 352.342 413.472 352.498C413.472 352.654 413.598 352.781 413.754 352.781Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M409.024 351.813C409.18 351.813 409.306 351.686 409.306 351.53C409.306 351.374 409.18 351.247 409.024 351.247C408.868 351.247 408.741 351.374 408.741 351.53C408.741 351.686 408.868 351.813 409.024 351.813Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M410.508 352.095C410.664 352.095 410.79 351.969 410.79 351.813C410.79 351.657 410.664 351.53 410.508 351.53C410.352 351.53 410.225 351.657 410.225 351.813C410.225 351.969 410.352 352.095 410.508 352.095Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M407.398 351.247C407.554 351.247 407.68 351.121 407.68 350.964C407.68 350.808 407.554 350.682 407.398 350.682C407.242 350.682 407.115 350.808 407.115 350.964C407.115 351.121 407.242 351.247 407.398 351.247Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M425.454 352.215C425.61 352.215 425.736 352.088 425.736 351.932C425.736 351.776 425.61 351.65 425.454 351.65C425.298 351.65 425.171 351.776 425.171 351.932C425.171 352.088 425.298 352.215 425.454 352.215Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M422.177 352.781C422.333 352.781 422.459 352.654 422.459 352.498C422.459 352.342 422.333 352.215 422.177 352.215C422.021 352.215 421.894 352.342 421.894 352.498C421.894 352.654 422.021 352.781 422.177 352.781Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M418.621 353.063C418.777 353.063 418.903 352.937 418.903 352.781C418.903 352.624 418.777 352.498 418.621 352.498C418.465 352.498 418.338 352.624 418.338 352.781C418.338 352.937 418.465 353.063 418.621 353.063Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M415.386 353.063C415.542 353.063 415.668 352.937 415.668 352.781C415.668 352.624 415.542 352.498 415.386 352.498C415.23 352.498 415.104 352.624 415.104 352.781C415.104 352.937 415.23 353.063 415.386 353.063Z",
    fill: "black"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M430.281 352.237C430.437 352.237 430.563 352.111 430.563 351.955C430.563 351.798 430.437 351.672 430.281 351.672C430.125 351.672 429.998 351.798 429.998 351.955C429.998 352.111 430.125 352.237 430.281 352.237Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M428.847 352.639C429.003 352.639 429.129 352.512 429.129 352.356C429.129 352.2 429.003 352.073 428.847 352.073C428.691 352.073 428.565 352.2 428.565 352.356C428.565 352.512 428.691 352.639 428.847 352.639Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M427.076 353.204C427.232 353.204 427.358 353.078 427.358 352.921C427.358 352.765 427.232 352.639 427.076 352.639C426.92 352.639 426.793 352.765 426.793 352.921C426.793 353.078 426.92 353.204 427.076 353.204Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M423.899 353.889C424.055 353.889 424.182 353.763 424.182 353.606C424.182 353.45 424.055 353.324 423.899 353.324C423.744 353.324 423.617 353.45 423.617 353.606C423.617 353.763 423.744 353.889 423.899 353.889Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M420.551 354.295C420.707 354.295 420.833 354.169 420.833 354.012C420.833 353.856 420.707 353.73 420.551 353.73C420.395 353.73 420.268 353.856 420.268 354.012C420.268 354.169 420.395 354.295 420.551 354.295Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M417.083 354.455C417.239 354.455 417.365 354.328 417.365 354.172C417.365 354.016 417.239 353.889 417.083 353.889C416.927 353.889 416.8 354.016 416.8 354.172C416.8 354.328 416.927 354.455 417.083 354.455Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M412.105 353.77C412.261 353.77 412.387 353.643 412.387 353.487C412.387 353.331 412.261 353.204 412.105 353.204C411.949 353.204 411.823 353.331 411.823 353.487C411.823 353.643 411.949 353.77 412.105 353.77Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M413.754 354.172C413.91 354.172 414.037 354.045 414.037 353.889C414.037 353.733 413.91 353.606 413.754 353.606C413.598 353.606 413.472 353.733 413.472 353.889C413.472 354.045 413.598 354.172 413.754 354.172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M409.024 353.204C409.18 353.204 409.306 353.078 409.306 352.921C409.306 352.765 409.18 352.639 409.024 352.639C408.868 352.639 408.741 352.765 408.741 352.921C408.741 353.078 408.868 353.204 409.024 353.204Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M410.508 353.487C410.664 353.487 410.79 353.36 410.79 353.204C410.79 353.048 410.664 352.921 410.508 352.921C410.352 352.921 410.225 353.048 410.225 353.204C410.225 353.36 410.352 353.487 410.508 353.487Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M407.398 352.639C407.554 352.639 407.68 352.512 407.68 352.356C407.68 352.2 407.554 352.073 407.398 352.073C407.242 352.073 407.115 352.2 407.115 352.356C407.115 352.512 407.242 352.639 407.398 352.639Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M425.454 353.606C425.61 353.606 425.736 353.48 425.736 353.324C425.736 353.168 425.61 353.041 425.454 353.041C425.298 353.041 425.171 353.168 425.171 353.324C425.171 353.48 425.298 353.606 425.454 353.606Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M422.177 354.172C422.333 354.172 422.459 354.045 422.459 353.889C422.459 353.733 422.333 353.606 422.177 353.606C422.021 353.606 421.894 353.733 421.894 353.889C421.894 354.045 422.021 354.172 422.177 354.172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M418.621 354.455C418.777 354.455 418.903 354.328 418.903 354.172C418.903 354.016 418.777 353.889 418.621 353.889C418.465 353.889 418.338 354.016 418.338 354.172C418.338 354.328 418.465 354.455 418.621 354.455Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M415.386 354.455C415.542 354.455 415.668 354.328 415.668 354.172C415.668 354.016 415.542 353.889 415.386 353.889C415.23 353.889 415.104 354.016 415.104 354.172C415.104 354.328 415.23 354.455 415.386 354.455Z",
    fill: "black"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M430.281 353.629C430.437 353.629 430.563 353.502 430.563 353.346C430.563 353.19 430.437 353.063 430.281 353.063C430.125 353.063 429.998 353.19 429.998 353.346C429.998 353.502 430.125 353.629 430.281 353.629Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M428.847 354.03C429.003 354.03 429.129 353.903 429.129 353.747C429.129 353.591 429.003 353.465 428.847 353.465C428.691 353.465 428.565 353.591 428.565 353.747C428.565 353.903 428.691 354.03 428.847 354.03Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M427.076 354.596C427.232 354.596 427.358 354.469 427.358 354.313C427.358 354.157 427.232 354.03 427.076 354.03C426.92 354.03 426.793 354.157 426.793 354.313C426.793 354.469 426.92 354.596 427.076 354.596Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M423.899 355.281C424.055 355.281 424.182 355.154 424.182 354.998C424.182 354.842 424.055 354.715 423.899 354.715C423.744 354.715 423.617 354.842 423.617 354.998C423.617 355.154 423.744 355.281 423.899 355.281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M420.551 355.687C420.707 355.687 420.833 355.56 420.833 355.404C420.833 355.248 420.707 355.121 420.551 355.121C420.395 355.121 420.268 355.248 420.268 355.404C420.268 355.56 420.395 355.687 420.551 355.687Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M417.083 355.846C417.239 355.846 417.365 355.72 417.365 355.563C417.365 355.407 417.239 355.281 417.083 355.281C416.927 355.281 416.8 355.407 416.8 355.563C416.8 355.72 416.927 355.846 417.083 355.846Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M412.105 355.161C412.261 355.161 412.387 355.035 412.387 354.878C412.387 354.722 412.261 354.596 412.105 354.596C411.949 354.596 411.823 354.722 411.823 354.878C411.823 355.035 411.949 355.161 412.105 355.161Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M413.754 355.563C413.91 355.563 414.037 355.437 414.037 355.281C414.037 355.125 413.91 354.998 413.754 354.998C413.598 354.998 413.472 355.125 413.472 355.281C413.472 355.437 413.598 355.563 413.754 355.563Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M409.024 354.596C409.18 354.596 409.306 354.469 409.306 354.313C409.306 354.157 409.18 354.03 409.024 354.03C408.868 354.03 408.741 354.157 408.741 354.313C408.741 354.469 408.868 354.596 409.024 354.596Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M410.508 354.878C410.664 354.878 410.79 354.752 410.79 354.596C410.79 354.439 410.664 354.313 410.508 354.313C410.352 354.313 410.225 354.439 410.225 354.596C410.225 354.752 410.352 354.878 410.508 354.878Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M407.398 354.03C407.554 354.03 407.68 353.903 407.68 353.747C407.68 353.591 407.554 353.465 407.398 353.465C407.242 353.465 407.115 353.591 407.115 353.747C407.115 353.903 407.242 354.03 407.398 354.03Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M425.454 354.998C425.61 354.998 425.736 354.871 425.736 354.715C425.736 354.559 425.61 354.432 425.454 354.432C425.298 354.432 425.171 354.559 425.171 354.715C425.171 354.871 425.298 354.998 425.454 354.998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M422.177 355.563C422.333 355.563 422.459 355.437 422.459 355.281C422.459 355.125 422.333 354.998 422.177 354.998C422.021 354.998 421.894 355.125 421.894 355.281C421.894 355.437 422.021 355.563 422.177 355.563Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M418.621 355.846C418.777 355.846 418.903 355.72 418.903 355.563C418.903 355.407 418.777 355.281 418.621 355.281C418.465 355.281 418.338 355.407 418.338 355.563C418.338 355.72 418.465 355.846 418.621 355.846Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M415.386 355.846C415.542 355.846 415.668 355.72 415.668 355.563C415.668 355.407 415.542 355.281 415.386 355.281C415.23 355.281 415.104 355.407 415.104 355.563C415.104 355.72 415.23 355.846 415.386 355.846Z",
    fill: "black"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M430.281 355.02C430.437 355.02 430.563 354.894 430.563 354.738C430.563 354.581 430.437 354.455 430.281 354.455C430.125 354.455 429.998 354.581 429.998 354.738C429.998 354.894 430.125 355.02 430.281 355.02Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M428.847 355.422C429.003 355.422 429.129 355.295 429.129 355.139C429.129 354.983 429.003 354.856 428.847 354.856C428.691 354.856 428.565 354.983 428.565 355.139C428.565 355.295 428.691 355.422 428.847 355.422Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M427.076 355.987C427.232 355.987 427.358 355.86 427.358 355.704C427.358 355.548 427.232 355.422 427.076 355.422C426.92 355.422 426.793 355.548 426.793 355.704C426.793 355.86 426.92 355.987 427.076 355.987Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M423.899 356.672C424.055 356.672 424.182 356.546 424.182 356.389C424.182 356.233 424.055 356.107 423.899 356.107C423.744 356.107 423.617 356.233 423.617 356.389C423.617 356.546 423.744 356.672 423.899 356.672Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M420.551 357.078C420.707 357.078 420.833 356.951 420.833 356.795C420.833 356.639 420.707 356.513 420.551 356.513C420.395 356.513 420.268 356.639 420.268 356.795C420.268 356.951 420.395 357.078 420.551 357.078Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M417.083 357.238C417.239 357.238 417.365 357.111 417.365 356.955C417.365 356.799 417.239 356.672 417.083 356.672C416.927 356.672 416.8 356.799 416.8 356.955C416.8 357.111 416.927 357.238 417.083 357.238Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M412.105 356.553C412.261 356.553 412.387 356.426 412.387 356.27C412.387 356.114 412.261 355.987 412.105 355.987C411.949 355.987 411.823 356.114 411.823 356.27C411.823 356.426 411.949 356.553 412.105 356.553Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M413.754 356.955C413.91 356.955 414.037 356.828 414.037 356.672C414.037 356.516 413.91 356.389 413.754 356.389C413.598 356.389 413.472 356.516 413.472 356.672C413.472 356.828 413.598 356.955 413.754 356.955Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M409.024 355.987C409.18 355.987 409.306 355.86 409.306 355.704C409.306 355.548 409.18 355.422 409.024 355.422C408.868 355.422 408.741 355.548 408.741 355.704C408.741 355.86 408.868 355.987 409.024 355.987Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M410.508 356.27C410.664 356.27 410.79 356.143 410.79 355.987C410.79 355.831 410.664 355.704 410.508 355.704C410.352 355.704 410.225 355.831 410.225 355.987C410.225 356.143 410.352 356.27 410.508 356.27Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M407.398 355.422C407.554 355.422 407.68 355.295 407.68 355.139C407.68 354.983 407.554 354.856 407.398 354.856C407.242 354.856 407.115 354.983 407.115 355.139C407.115 355.295 407.242 355.422 407.398 355.422Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M425.454 356.389C425.61 356.389 425.736 356.263 425.736 356.107C425.736 355.95 425.61 355.824 425.454 355.824C425.298 355.824 425.171 355.95 425.171 356.107C425.171 356.263 425.298 356.389 425.454 356.389Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M422.177 356.955C422.333 356.955 422.459 356.828 422.459 356.672C422.459 356.516 422.333 356.389 422.177 356.389C422.021 356.389 421.894 356.516 421.894 356.672C421.894 356.828 422.021 356.955 422.177 356.955Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M418.621 357.238C418.777 357.238 418.903 357.111 418.903 356.955C418.903 356.799 418.777 356.672 418.621 356.672C418.465 356.672 418.338 356.799 418.338 356.955C418.338 357.111 418.465 357.238 418.621 357.238Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M415.386 357.238C415.542 357.238 415.668 357.111 415.668 356.955C415.668 356.799 415.542 356.672 415.386 356.672C415.23 356.672 415.104 356.799 415.104 356.955C415.104 357.111 415.23 357.238 415.386 357.238Z",
    fill: "black"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M430.281 356.412C430.437 356.412 430.563 356.285 430.563 356.129C430.563 355.973 430.437 355.846 430.281 355.846C430.125 355.846 429.998 355.973 429.998 356.129C429.998 356.285 430.125 356.412 430.281 356.412Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M428.847 356.813C429.003 356.813 429.129 356.686 429.129 356.53C429.129 356.374 429.003 356.247 428.847 356.247C428.691 356.247 428.565 356.374 428.565 356.53C428.565 356.686 428.691 356.813 428.847 356.813Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M427.076 357.379C427.232 357.379 427.358 357.252 427.358 357.096C427.358 356.94 427.232 356.813 427.076 356.813C426.92 356.813 426.793 356.94 426.793 357.096C426.793 357.252 426.92 357.379 427.076 357.379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M423.899 358.064C424.055 358.064 424.182 357.937 424.182 357.781C424.182 357.625 424.055 357.498 423.899 357.498C423.744 357.498 423.617 357.625 423.617 357.781C423.617 357.937 423.744 358.064 423.899 358.064Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M420.551 358.469C420.707 358.469 420.833 358.343 420.833 358.187C420.833 358.031 420.707 357.904 420.551 357.904C420.395 357.904 420.268 358.031 420.268 358.187C420.268 358.343 420.395 358.469 420.551 358.469Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M417.083 358.629C417.239 358.629 417.365 358.502 417.365 358.346C417.365 358.19 417.239 358.064 417.083 358.064C416.927 358.064 416.8 358.19 416.8 358.346C416.8 358.502 416.927 358.629 417.083 358.629Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M412.105 357.944C412.261 357.944 412.387 357.817 412.387 357.661C412.387 357.505 412.261 357.379 412.105 357.379C411.949 357.379 411.823 357.505 411.823 357.661C411.823 357.817 411.949 357.944 412.105 357.944Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M413.754 358.346C413.91 358.346 414.037 358.22 414.037 358.064C414.037 357.907 413.91 357.781 413.754 357.781C413.598 357.781 413.472 357.907 413.472 358.064C413.472 358.22 413.598 358.346 413.754 358.346Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M409.024 357.379C409.18 357.379 409.306 357.252 409.306 357.096C409.306 356.94 409.18 356.813 409.024 356.813C408.868 356.813 408.741 356.94 408.741 357.096C408.741 357.252 408.868 357.379 409.024 357.379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M410.508 357.661C410.664 357.661 410.79 357.535 410.79 357.379C410.79 357.222 410.664 357.096 410.508 357.096C410.352 357.096 410.225 357.222 410.225 357.379C410.225 357.535 410.352 357.661 410.508 357.661Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M407.398 356.813C407.554 356.813 407.68 356.686 407.68 356.53C407.68 356.374 407.554 356.247 407.398 356.247C407.242 356.247 407.115 356.374 407.115 356.53C407.115 356.686 407.242 356.813 407.398 356.813Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M425.454 357.781C425.61 357.781 425.736 357.654 425.736 357.498C425.736 357.342 425.61 357.215 425.454 357.215C425.298 357.215 425.171 357.342 425.171 357.498C425.171 357.654 425.298 357.781 425.454 357.781Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M422.177 358.346C422.333 358.346 422.459 358.22 422.459 358.064C422.459 357.907 422.333 357.781 422.177 357.781C422.021 357.781 421.894 357.907 421.894 358.064C421.894 358.22 422.021 358.346 422.177 358.346Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M418.621 358.629C418.777 358.629 418.903 358.502 418.903 358.346C418.903 358.19 418.777 358.064 418.621 358.064C418.465 358.064 418.338 358.19 418.338 358.346C418.338 358.502 418.465 358.629 418.621 358.629Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M415.386 358.629C415.542 358.629 415.668 358.502 415.668 358.346C415.668 358.19 415.542 358.064 415.386 358.064C415.23 358.064 415.104 358.19 415.104 358.346C415.104 358.502 415.23 358.629 415.386 358.629Z",
    fill: "black"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M430.281 357.803C430.437 357.803 430.563 357.677 430.563 357.52C430.563 357.364 430.437 357.238 430.281 357.238C430.125 357.238 429.998 357.364 429.998 357.52C429.998 357.677 430.125 357.803 430.281 357.803Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M428.847 358.204C429.003 358.204 429.129 358.078 429.129 357.922C429.129 357.766 429.003 357.639 428.847 357.639C428.691 357.639 428.565 357.766 428.565 357.922C428.565 358.078 428.691 358.204 428.847 358.204Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M427.076 358.77C427.232 358.77 427.358 358.643 427.358 358.487C427.358 358.331 427.232 358.204 427.076 358.204C426.92 358.204 426.793 358.331 426.793 358.487C426.793 358.643 426.92 358.77 427.076 358.77Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M423.899 359.455C424.055 359.455 424.182 359.328 424.182 359.172C424.182 359.016 424.055 358.89 423.899 358.89C423.744 358.89 423.617 359.016 423.617 359.172C423.617 359.328 423.744 359.455 423.899 359.455Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M420.551 359.861C420.707 359.861 420.833 359.734 420.833 359.578C420.833 359.422 420.707 359.295 420.551 359.295C420.395 359.295 420.268 359.422 420.268 359.578C420.268 359.734 420.395 359.861 420.551 359.861Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M417.083 360.021C417.239 360.021 417.365 359.894 417.365 359.738C417.365 359.582 417.239 359.455 417.083 359.455C416.927 359.455 416.8 359.582 416.8 359.738C416.8 359.894 416.927 360.021 417.083 360.021Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M412.105 359.335C412.261 359.335 412.387 359.209 412.387 359.053C412.387 358.897 412.261 358.77 412.105 358.77C411.949 358.77 411.823 358.897 411.823 359.053C411.823 359.209 411.949 359.335 412.105 359.335Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M413.754 359.738C413.91 359.738 414.037 359.611 414.037 359.455C414.037 359.299 413.91 359.172 413.754 359.172C413.598 359.172 413.472 359.299 413.472 359.455C413.472 359.611 413.598 359.738 413.754 359.738Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M409.024 358.77C409.18 358.77 409.306 358.643 409.306 358.487C409.306 358.331 409.18 358.204 409.024 358.204C408.868 358.204 408.741 358.331 408.741 358.487C408.741 358.643 408.868 358.77 409.024 358.77Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M410.508 359.053C410.664 359.053 410.79 358.926 410.79 358.77C410.79 358.614 410.664 358.487 410.508 358.487C410.352 358.487 410.225 358.614 410.225 358.77C410.225 358.926 410.352 359.053 410.508 359.053Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M407.398 358.204C407.554 358.204 407.68 358.078 407.68 357.922C407.68 357.766 407.554 357.639 407.398 357.639C407.242 357.639 407.115 357.766 407.115 357.922C407.115 358.078 407.242 358.204 407.398 358.204Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M425.454 359.172C425.61 359.172 425.736 359.046 425.736 358.89C425.736 358.733 425.61 358.607 425.454 358.607C425.298 358.607 425.171 358.733 425.171 358.89C425.171 359.046 425.298 359.172 425.454 359.172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M422.177 359.738C422.333 359.738 422.459 359.611 422.459 359.455C422.459 359.299 422.333 359.172 422.177 359.172C422.021 359.172 421.894 359.299 421.894 359.455C421.894 359.611 422.021 359.738 422.177 359.738Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M418.621 360.021C418.777 360.021 418.903 359.894 418.903 359.738C418.903 359.582 418.777 359.455 418.621 359.455C418.465 359.455 418.338 359.582 418.338 359.738C418.338 359.894 418.465 360.021 418.621 360.021Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M415.386 360.021C415.542 360.021 415.668 359.894 415.668 359.738C415.668 359.582 415.542 359.455 415.386 359.455C415.23 359.455 415.104 359.582 415.104 359.738C415.104 359.894 415.23 360.021 415.386 360.021Z",
    fill: "black"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M430.281 359.195C430.437 359.195 430.563 359.068 430.563 358.912C430.563 358.756 430.437 358.629 430.281 358.629C430.125 358.629 429.998 358.756 429.998 358.912C429.998 359.068 430.125 359.195 430.281 359.195Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M428.847 359.596C429.003 359.596 429.129 359.469 429.129 359.313C429.129 359.157 429.003 359.03 428.847 359.03C428.691 359.03 428.565 359.157 428.565 359.313C428.565 359.469 428.691 359.596 428.847 359.596Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M427.076 360.161C427.232 360.161 427.358 360.035 427.358 359.879C427.358 359.722 427.232 359.596 427.076 359.596C426.92 359.596 426.793 359.722 426.793 359.879C426.793 360.035 426.92 360.161 427.076 360.161Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M423.899 360.846C424.055 360.846 424.182 360.72 424.182 360.564C424.182 360.408 424.055 360.281 423.899 360.281C423.744 360.281 423.617 360.408 423.617 360.564C423.617 360.72 423.744 360.846 423.899 360.846Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M420.551 361.252C420.707 361.252 420.833 361.126 420.833 360.97C420.833 360.813 420.707 360.687 420.551 360.687C420.395 360.687 420.268 360.813 420.268 360.97C420.268 361.126 420.395 361.252 420.551 361.252Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M417.083 361.412C417.239 361.412 417.365 361.285 417.365 361.129C417.365 360.973 417.239 360.846 417.083 360.846C416.927 360.846 416.8 360.973 416.8 361.129C416.8 361.285 416.927 361.412 417.083 361.412Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M412.105 360.727C412.261 360.727 412.387 360.6 412.387 360.444C412.387 360.288 412.261 360.161 412.105 360.161C411.949 360.161 411.823 360.288 411.823 360.444C411.823 360.6 411.949 360.727 412.105 360.727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M413.754 361.129C413.91 361.129 414.037 361.003 414.037 360.846C414.037 360.69 413.91 360.564 413.754 360.564C413.598 360.564 413.472 360.69 413.472 360.846C413.472 361.003 413.598 361.129 413.754 361.129Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M409.024 360.161C409.18 360.161 409.306 360.035 409.306 359.879C409.306 359.722 409.18 359.596 409.024 359.596C408.868 359.596 408.741 359.722 408.741 359.879C408.741 360.035 408.868 360.161 409.024 360.161Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M410.508 360.444C410.664 360.444 410.79 360.318 410.79 360.161C410.79 360.005 410.664 359.879 410.508 359.879C410.352 359.879 410.225 360.005 410.225 360.161C410.225 360.318 410.352 360.444 410.508 360.444Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M407.398 359.596C407.554 359.596 407.68 359.469 407.68 359.313C407.68 359.157 407.554 359.03 407.398 359.03C407.242 359.03 407.115 359.157 407.115 359.313C407.115 359.469 407.242 359.596 407.398 359.596Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M425.454 360.564C425.61 360.564 425.736 360.437 425.736 360.281C425.736 360.125 425.61 359.998 425.454 359.998C425.298 359.998 425.171 360.125 425.171 360.281C425.171 360.437 425.298 360.564 425.454 360.564Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M422.177 361.129C422.333 361.129 422.459 361.003 422.459 360.846C422.459 360.69 422.333 360.564 422.177 360.564C422.021 360.564 421.894 360.69 421.894 360.846C421.894 361.003 422.021 361.129 422.177 361.129Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M418.621 361.412C418.777 361.412 418.903 361.285 418.903 361.129C418.903 360.973 418.777 360.846 418.621 360.846C418.465 360.846 418.338 360.973 418.338 361.129C418.338 361.285 418.465 361.412 418.621 361.412Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M415.386 361.412C415.542 361.412 415.668 361.285 415.668 361.129C415.668 360.973 415.542 360.846 415.386 360.846C415.23 360.846 415.104 360.973 415.104 361.129C415.104 361.285 415.23 361.412 415.386 361.412Z",
    fill: "black"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M430.281 360.586C430.437 360.586 430.563 360.459 430.563 360.303C430.563 360.147 430.437 360.021 430.281 360.021C430.125 360.021 429.998 360.147 429.998 360.303C429.998 360.459 430.125 360.586 430.281 360.586Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M428.847 360.987C429.003 360.987 429.129 360.861 429.129 360.705C429.129 360.548 429.003 360.422 428.847 360.422C428.691 360.422 428.565 360.548 428.565 360.705C428.565 360.861 428.691 360.987 428.847 360.987Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M427.076 361.553C427.232 361.553 427.358 361.426 427.358 361.27C427.358 361.114 427.232 360.987 427.076 360.987C426.92 360.987 426.793 361.114 426.793 361.27C426.793 361.426 426.92 361.553 427.076 361.553Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M423.899 362.238C424.055 362.238 424.182 362.111 424.182 361.955C424.182 361.799 424.055 361.672 423.899 361.672C423.744 361.672 423.617 361.799 423.617 361.955C423.617 362.111 423.744 362.238 423.899 362.238Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M420.551 362.644C420.707 362.644 420.833 362.517 420.833 362.361C420.833 362.205 420.707 362.078 420.551 362.078C420.395 362.078 420.268 362.205 420.268 362.361C420.268 362.517 420.395 362.644 420.551 362.644Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M417.083 362.803C417.239 362.803 417.365 362.677 417.365 362.521C417.365 362.365 417.239 362.238 417.083 362.238C416.927 362.238 416.8 362.365 416.8 362.521C416.8 362.677 416.927 362.803 417.083 362.803Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M412.105 362.118C412.261 362.118 412.387 361.992 412.387 361.836C412.387 361.679 412.261 361.553 412.105 361.553C411.949 361.553 411.823 361.679 411.823 361.836C411.823 361.992 411.949 362.118 412.105 362.118Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M413.754 362.521C413.91 362.521 414.037 362.394 414.037 362.238C414.037 362.082 413.91 361.955 413.754 361.955C413.598 361.955 413.472 362.082 413.472 362.238C413.472 362.394 413.598 362.521 413.754 362.521Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M409.024 361.553C409.18 361.553 409.306 361.426 409.306 361.27C409.306 361.114 409.18 360.987 409.024 360.987C408.868 360.987 408.741 361.114 408.741 361.27C408.741 361.426 408.868 361.553 409.024 361.553Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M410.508 361.836C410.664 361.836 410.79 361.709 410.79 361.553C410.79 361.397 410.664 361.27 410.508 361.27C410.352 361.27 410.225 361.397 410.225 361.553C410.225 361.709 410.352 361.836 410.508 361.836Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M407.398 360.987C407.554 360.987 407.68 360.861 407.68 360.705C407.68 360.548 407.554 360.422 407.398 360.422C407.242 360.422 407.115 360.548 407.115 360.705C407.115 360.861 407.242 360.987 407.398 360.987Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M425.454 361.955C425.61 361.955 425.736 361.829 425.736 361.672C425.736 361.516 425.61 361.39 425.454 361.39C425.298 361.39 425.171 361.516 425.171 361.672C425.171 361.829 425.298 361.955 425.454 361.955Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M422.177 362.521C422.333 362.521 422.459 362.394 422.459 362.238C422.459 362.082 422.333 361.955 422.177 361.955C422.021 361.955 421.894 362.082 421.894 362.238C421.894 362.394 422.021 362.521 422.177 362.521Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M418.621 362.803C418.777 362.803 418.903 362.677 418.903 362.521C418.903 362.365 418.777 362.238 418.621 362.238C418.465 362.238 418.338 362.365 418.338 362.521C418.338 362.677 418.465 362.803 418.621 362.803Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M415.386 362.803C415.542 362.803 415.668 362.677 415.668 362.521C415.668 362.365 415.542 362.238 415.386 362.238C415.23 362.238 415.104 362.365 415.104 362.521C415.104 362.677 415.23 362.803 415.386 362.803Z",
    fill: "black"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M430.281 361.977C430.437 361.977 430.563 361.851 430.563 361.695C430.563 361.539 430.437 361.412 430.281 361.412C430.125 361.412 429.998 361.539 429.998 361.695C429.998 361.851 430.125 361.977 430.281 361.977Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M428.847 362.379C429.003 362.379 429.129 362.252 429.129 362.096C429.129 361.94 429.003 361.813 428.847 361.813C428.691 361.813 428.565 361.94 428.565 362.096C428.565 362.252 428.691 362.379 428.847 362.379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M427.076 362.944C427.232 362.944 427.358 362.818 427.358 362.662C427.358 362.505 427.232 362.379 427.076 362.379C426.92 362.379 426.793 362.505 426.793 362.662C426.793 362.818 426.92 362.944 427.076 362.944Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M423.899 363.629C424.055 363.629 424.182 363.503 424.182 363.347C424.182 363.19 424.055 363.064 423.899 363.064C423.744 363.064 423.617 363.19 423.617 363.347C423.617 363.503 423.744 363.629 423.899 363.629Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M420.551 364.035C420.707 364.035 420.833 363.909 420.833 363.753C420.833 363.596 420.707 363.47 420.551 363.47C420.395 363.47 420.268 363.596 420.268 363.753C420.268 363.909 420.395 364.035 420.551 364.035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M417.083 364.195C417.239 364.195 417.365 364.068 417.365 363.912C417.365 363.756 417.239 363.629 417.083 363.629C416.927 363.629 416.8 363.756 416.8 363.912C416.8 364.068 416.927 364.195 417.083 364.195Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M412.105 363.51C412.261 363.51 412.387 363.383 412.387 363.227C412.387 363.071 412.261 362.944 412.105 362.944C411.949 362.944 411.823 363.071 411.823 363.227C411.823 363.383 411.949 363.51 412.105 363.51Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M413.754 363.912C413.91 363.912 414.037 363.786 414.037 363.629C414.037 363.473 413.91 363.347 413.754 363.347C413.598 363.347 413.472 363.473 413.472 363.629C413.472 363.786 413.598 363.912 413.754 363.912Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M409.024 362.944C409.18 362.944 409.306 362.818 409.306 362.662C409.306 362.505 409.18 362.379 409.024 362.379C408.868 362.379 408.741 362.505 408.741 362.662C408.741 362.818 408.868 362.944 409.024 362.944Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M410.508 363.227C410.664 363.227 410.79 363.1 410.79 362.944C410.79 362.788 410.664 362.662 410.508 362.662C410.352 362.662 410.225 362.788 410.225 362.944C410.225 363.1 410.352 363.227 410.508 363.227Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M407.398 362.379C407.554 362.379 407.68 362.252 407.68 362.096C407.68 361.94 407.554 361.813 407.398 361.813C407.242 361.813 407.115 361.94 407.115 362.096C407.115 362.252 407.242 362.379 407.398 362.379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M425.454 363.347C425.61 363.347 425.736 363.22 425.736 363.064C425.736 362.908 425.61 362.781 425.454 362.781C425.298 362.781 425.171 362.908 425.171 363.064C425.171 363.22 425.298 363.347 425.454 363.347Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M422.177 363.912C422.333 363.912 422.459 363.786 422.459 363.629C422.459 363.473 422.333 363.347 422.177 363.347C422.021 363.347 421.894 363.473 421.894 363.629C421.894 363.786 422.021 363.912 422.177 363.912Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M418.621 364.195C418.777 364.195 418.903 364.068 418.903 363.912C418.903 363.756 418.777 363.629 418.621 363.629C418.465 363.629 418.338 363.756 418.338 363.912C418.338 364.068 418.465 364.195 418.621 364.195Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M415.386 364.195C415.542 364.195 415.668 364.068 415.668 363.912C415.668 363.756 415.542 363.629 415.386 363.629C415.23 363.629 415.104 363.756 415.104 363.912C415.104 364.068 415.23 364.195 415.386 364.195Z",
    fill: "black"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M430.281 363.369C430.437 363.369 430.563 363.242 430.563 363.086C430.563 362.93 430.437 362.803 430.281 362.803C430.125 362.803 429.998 362.93 429.998 363.086C429.998 363.242 430.125 363.369 430.281 363.369Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M428.847 363.77C429.003 363.77 429.129 363.644 429.129 363.487C429.129 363.331 429.003 363.205 428.847 363.205C428.691 363.205 428.565 363.331 428.565 363.487C428.565 363.644 428.691 363.77 428.847 363.77Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M427.076 364.336C427.232 364.336 427.358 364.209 427.358 364.053C427.358 363.897 427.232 363.77 427.076 363.77C426.92 363.77 426.793 363.897 426.793 364.053C426.793 364.209 426.92 364.336 427.076 364.336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M423.899 365.021C424.055 365.021 424.182 364.894 424.182 364.738C424.182 364.582 424.055 364.455 423.899 364.455C423.744 364.455 423.617 364.582 423.617 364.738C423.617 364.894 423.744 365.021 423.899 365.021Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M420.551 365.427C420.707 365.427 420.833 365.3 420.833 365.144C420.833 364.988 420.707 364.861 420.551 364.861C420.395 364.861 420.268 364.988 420.268 365.144C420.268 365.3 420.395 365.427 420.551 365.427Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M417.083 365.586C417.239 365.586 417.365 365.46 417.365 365.304C417.365 365.147 417.239 365.021 417.083 365.021C416.927 365.021 416.8 365.147 416.8 365.304C416.8 365.46 416.927 365.586 417.083 365.586Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M412.105 364.901C412.261 364.901 412.387 364.775 412.387 364.619C412.387 364.462 412.261 364.336 412.105 364.336C411.949 364.336 411.823 364.462 411.823 364.619C411.823 364.775 411.949 364.901 412.105 364.901Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M413.754 365.304C413.91 365.304 414.037 365.177 414.037 365.021C414.037 364.865 413.91 364.738 413.754 364.738C413.598 364.738 413.472 364.865 413.472 365.021C413.472 365.177 413.598 365.304 413.754 365.304Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M409.024 364.336C409.18 364.336 409.306 364.209 409.306 364.053C409.306 363.897 409.18 363.77 409.024 363.77C408.868 363.77 408.741 363.897 408.741 364.053C408.741 364.209 408.868 364.336 409.024 364.336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M410.508 364.618C410.664 364.618 410.79 364.492 410.79 364.336C410.79 364.18 410.664 364.053 410.508 364.053C410.352 364.053 410.225 364.18 410.225 364.336C410.225 364.492 410.352 364.618 410.508 364.618Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M407.398 363.77C407.554 363.77 407.68 363.644 407.68 363.487C407.68 363.331 407.554 363.205 407.398 363.205C407.242 363.205 407.115 363.331 407.115 363.487C407.115 363.644 407.242 363.77 407.398 363.77Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M425.454 364.738C425.61 364.738 425.736 364.611 425.736 364.455C425.736 364.299 425.61 364.173 425.454 364.173C425.298 364.173 425.171 364.299 425.171 364.455C425.171 364.611 425.298 364.738 425.454 364.738Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M422.177 365.304C422.333 365.304 422.459 365.177 422.459 365.021C422.459 364.865 422.333 364.738 422.177 364.738C422.021 364.738 421.894 364.865 421.894 365.021C421.894 365.177 422.021 365.304 422.177 365.304Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M418.621 365.586C418.777 365.586 418.903 365.46 418.903 365.304C418.903 365.147 418.777 365.021 418.621 365.021C418.465 365.021 418.338 365.147 418.338 365.304C418.338 365.46 418.465 365.586 418.621 365.586Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M415.386 365.586C415.542 365.586 415.668 365.46 415.668 365.304C415.668 365.147 415.542 365.021 415.386 365.021C415.23 365.021 415.104 365.147 415.104 365.304C415.104 365.46 415.23 365.586 415.386 365.586Z",
    fill: "black"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M430.281 364.76C430.437 364.76 430.563 364.634 430.563 364.478C430.563 364.321 430.437 364.195 430.281 364.195C430.125 364.195 429.998 364.321 429.998 364.478C429.998 364.634 430.125 364.76 430.281 364.76Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M428.847 365.162C429.003 365.162 429.129 365.035 429.129 364.879C429.129 364.723 429.003 364.596 428.847 364.596C428.691 364.596 428.565 364.723 428.565 364.879C428.565 365.035 428.691 365.162 428.847 365.162Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M427.076 365.727C427.232 365.727 427.358 365.601 427.358 365.444C427.358 365.288 427.232 365.162 427.076 365.162C426.92 365.162 426.793 365.288 426.793 365.444C426.793 365.601 426.92 365.727 427.076 365.727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M423.899 366.412C424.055 366.412 424.182 366.286 424.182 366.13C424.182 365.973 424.055 365.847 423.899 365.847C423.744 365.847 423.617 365.973 423.617 366.13C423.617 366.286 423.744 366.412 423.899 366.412Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M420.551 366.818C420.707 366.818 420.833 366.692 420.833 366.535C420.833 366.379 420.707 366.253 420.551 366.253C420.395 366.253 420.268 366.379 420.268 366.535C420.268 366.692 420.395 366.818 420.551 366.818Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M417.083 366.978C417.239 366.978 417.365 366.851 417.365 366.695C417.365 366.539 417.239 366.412 417.083 366.412C416.927 366.412 416.8 366.539 416.8 366.695C416.8 366.851 416.927 366.978 417.083 366.978Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M412.105 366.293C412.261 366.293 412.387 366.166 412.387 366.01C412.387 365.854 412.261 365.727 412.105 365.727C411.949 365.727 411.823 365.854 411.823 366.01C411.823 366.166 411.949 366.293 412.105 366.293Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M413.754 366.695C413.91 366.695 414.037 366.568 414.037 366.412C414.037 366.256 413.91 366.13 413.754 366.13C413.598 366.13 413.472 366.256 413.472 366.412C413.472 366.568 413.598 366.695 413.754 366.695Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M409.024 365.727C409.18 365.727 409.306 365.601 409.306 365.444C409.306 365.288 409.18 365.162 409.024 365.162C408.868 365.162 408.741 365.288 408.741 365.444C408.741 365.601 408.868 365.727 409.024 365.727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M410.508 366.01C410.664 366.01 410.79 365.883 410.79 365.727C410.79 365.571 410.664 365.444 410.508 365.444C410.352 365.444 410.225 365.571 410.225 365.727C410.225 365.883 410.352 366.01 410.508 366.01Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M407.398 365.162C407.554 365.162 407.68 365.035 407.68 364.879C407.68 364.723 407.554 364.596 407.398 364.596C407.242 364.596 407.115 364.723 407.115 364.879C407.115 365.035 407.242 365.162 407.398 365.162Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M425.454 366.13C425.61 366.13 425.736 366.003 425.736 365.847C425.736 365.691 425.61 365.564 425.454 365.564C425.298 365.564 425.171 365.691 425.171 365.847C425.171 366.003 425.298 366.13 425.454 366.13Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M422.177 366.695C422.333 366.695 422.459 366.568 422.459 366.412C422.459 366.256 422.333 366.13 422.177 366.13C422.021 366.13 421.894 366.256 421.894 366.412C421.894 366.568 422.021 366.695 422.177 366.695Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M418.621 366.978C418.777 366.978 418.903 366.851 418.903 366.695C418.903 366.539 418.777 366.412 418.621 366.412C418.465 366.412 418.338 366.539 418.338 366.695C418.338 366.851 418.465 366.978 418.621 366.978Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M415.386 366.978C415.542 366.978 415.668 366.851 415.668 366.695C415.668 366.539 415.542 366.412 415.386 366.412C415.23 366.412 415.104 366.539 415.104 366.695C415.104 366.851 415.23 366.978 415.386 366.978Z",
    fill: "black"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M430.281 366.152C430.437 366.152 430.563 366.025 430.563 365.869C430.563 365.713 430.437 365.586 430.281 365.586C430.125 365.586 429.998 365.713 429.998 365.869C429.998 366.025 430.125 366.152 430.281 366.152Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M428.847 366.553C429.003 366.553 429.129 366.427 429.129 366.27C429.129 366.114 429.003 365.988 428.847 365.988C428.691 365.988 428.565 366.114 428.565 366.27C428.565 366.427 428.691 366.553 428.847 366.553Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M427.076 367.119C427.232 367.119 427.358 366.992 427.358 366.836C427.358 366.68 427.232 366.553 427.076 366.553C426.92 366.553 426.793 366.68 426.793 366.836C426.793 366.992 426.92 367.119 427.076 367.119Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M423.899 367.804C424.055 367.804 424.182 367.677 424.182 367.521C424.182 367.365 424.055 367.238 423.899 367.238C423.744 367.238 423.617 367.365 423.617 367.521C423.617 367.677 423.744 367.804 423.899 367.804Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M420.551 368.21C420.707 368.21 420.833 368.083 420.833 367.927C420.833 367.771 420.707 367.644 420.551 367.644C420.395 367.644 420.268 367.771 420.268 367.927C420.268 368.083 420.395 368.21 420.551 368.21Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M417.083 368.369C417.239 368.369 417.365 368.243 417.365 368.086C417.365 367.93 417.239 367.804 417.083 367.804C416.927 367.804 416.8 367.93 416.8 368.086C416.8 368.243 416.927 368.369 417.083 368.369Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M412.105 367.684C412.261 367.684 412.387 367.558 412.387 367.401C412.387 367.245 412.261 367.119 412.105 367.119C411.949 367.119 411.823 367.245 411.823 367.401C411.823 367.558 411.949 367.684 412.105 367.684Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M413.754 368.086C413.91 368.086 414.037 367.96 414.037 367.804C414.037 367.648 413.91 367.521 413.754 367.521C413.598 367.521 413.472 367.648 413.472 367.804C413.472 367.96 413.598 368.086 413.754 368.086Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M409.024 367.119C409.18 367.119 409.306 366.992 409.306 366.836C409.306 366.68 409.18 366.553 409.024 366.553C408.868 366.553 408.741 366.68 408.741 366.836C408.741 366.992 408.868 367.119 409.024 367.119Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M410.508 367.401C410.664 367.401 410.79 367.275 410.79 367.119C410.79 366.962 410.664 366.836 410.508 366.836C410.352 366.836 410.225 366.962 410.225 367.119C410.225 367.275 410.352 367.401 410.508 367.401Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M407.398 366.553C407.554 366.553 407.68 366.427 407.68 366.27C407.68 366.114 407.554 365.988 407.398 365.988C407.242 365.988 407.115 366.114 407.115 366.27C407.115 366.427 407.242 366.553 407.398 366.553Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M425.454 367.521C425.61 367.521 425.736 367.394 425.736 367.238C425.736 367.082 425.61 366.955 425.454 366.955C425.298 366.955 425.171 367.082 425.171 367.238C425.171 367.394 425.298 367.521 425.454 367.521Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M422.177 368.086C422.333 368.086 422.459 367.96 422.459 367.804C422.459 367.648 422.333 367.521 422.177 367.521C422.021 367.521 421.894 367.648 421.894 367.804C421.894 367.96 422.021 368.086 422.177 368.086Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M418.621 368.369C418.777 368.369 418.903 368.243 418.903 368.086C418.903 367.93 418.777 367.804 418.621 367.804C418.465 367.804 418.338 367.93 418.338 368.086C418.338 368.243 418.465 368.369 418.621 368.369Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M415.386 368.369C415.542 368.369 415.668 368.243 415.668 368.086C415.668 367.93 415.542 367.804 415.386 367.804C415.23 367.804 415.104 367.93 415.104 368.086C415.104 368.243 415.23 368.369 415.386 368.369Z",
    fill: "black"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M430.281 367.543C430.437 367.543 430.563 367.417 430.563 367.261C430.563 367.104 430.437 366.978 430.281 366.978C430.125 366.978 429.998 367.104 429.998 367.261C429.998 367.417 430.125 367.543 430.281 367.543Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M428.847 367.945C429.003 367.945 429.129 367.818 429.129 367.662C429.129 367.506 429.003 367.379 428.847 367.379C428.691 367.379 428.565 367.506 428.565 367.662C428.565 367.818 428.691 367.945 428.847 367.945Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M427.076 368.51C427.232 368.51 427.358 368.383 427.358 368.227C427.358 368.071 427.232 367.945 427.076 367.945C426.92 367.945 426.793 368.071 426.793 368.227C426.793 368.383 426.92 368.51 427.076 368.51Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M423.899 369.195C424.055 369.195 424.182 369.069 424.182 368.912C424.182 368.756 424.055 368.63 423.899 368.63C423.744 368.63 423.617 368.756 423.617 368.912C423.617 369.069 423.744 369.195 423.899 369.195Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M420.551 369.601C420.707 369.601 420.833 369.474 420.833 369.318C420.833 369.162 420.707 369.036 420.551 369.036C420.395 369.036 420.268 369.162 420.268 369.318C420.268 369.474 420.395 369.601 420.551 369.601Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M417.083 369.761C417.239 369.761 417.365 369.634 417.365 369.478C417.365 369.322 417.239 369.195 417.083 369.195C416.927 369.195 416.8 369.322 416.8 369.478C416.8 369.634 416.927 369.761 417.083 369.761Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M412.105 369.076C412.261 369.076 412.387 368.949 412.387 368.793C412.387 368.637 412.261 368.51 412.105 368.51C411.949 368.51 411.823 368.637 411.823 368.793C411.823 368.949 411.949 369.076 412.105 369.076Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M413.754 369.478C413.91 369.478 414.037 369.351 414.037 369.195C414.037 369.039 413.91 368.912 413.754 368.912C413.598 368.912 413.472 369.039 413.472 369.195C413.472 369.351 413.598 369.478 413.754 369.478Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M409.024 368.51C409.18 368.51 409.306 368.383 409.306 368.227C409.306 368.071 409.18 367.945 409.024 367.945C408.868 367.945 408.741 368.071 408.741 368.227C408.741 368.383 408.868 368.51 409.024 368.51Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M410.508 368.793C410.664 368.793 410.79 368.666 410.79 368.51C410.79 368.354 410.664 368.227 410.508 368.227C410.352 368.227 410.225 368.354 410.225 368.51C410.225 368.666 410.352 368.793 410.508 368.793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M407.398 367.945C407.554 367.945 407.68 367.818 407.68 367.662C407.68 367.506 407.554 367.379 407.398 367.379C407.242 367.379 407.115 367.506 407.115 367.662C407.115 367.818 407.242 367.945 407.398 367.945Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M425.454 368.912C425.61 368.912 425.736 368.786 425.736 368.63C425.736 368.473 425.61 368.347 425.454 368.347C425.298 368.347 425.171 368.473 425.171 368.63C425.171 368.786 425.298 368.912 425.454 368.912Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M422.177 369.478C422.333 369.478 422.459 369.351 422.459 369.195C422.459 369.039 422.333 368.912 422.177 368.912C422.021 368.912 421.894 369.039 421.894 369.195C421.894 369.351 422.021 369.478 422.177 369.478Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M418.621 369.761C418.777 369.761 418.903 369.634 418.903 369.478C418.903 369.322 418.777 369.195 418.621 369.195C418.465 369.195 418.338 369.322 418.338 369.478C418.338 369.634 418.465 369.761 418.621 369.761Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M415.386 369.761C415.542 369.761 415.668 369.634 415.668 369.478C415.668 369.322 415.542 369.195 415.386 369.195C415.23 369.195 415.104 369.322 415.104 369.478C415.104 369.634 415.23 369.761 415.386 369.761Z",
    fill: "black"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M430.281 368.935C430.437 368.935 430.563 368.808 430.563 368.652C430.563 368.496 430.437 368.369 430.281 368.369C430.125 368.369 429.998 368.496 429.998 368.652C429.998 368.808 430.125 368.935 430.281 368.935Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M428.847 369.336C429.003 369.336 429.129 369.209 429.129 369.053C429.129 368.897 429.003 368.771 428.847 368.771C428.691 368.771 428.565 368.897 428.565 369.053C428.565 369.209 428.691 369.336 428.847 369.336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M427.076 369.902C427.232 369.902 427.358 369.775 427.358 369.619C427.358 369.463 427.232 369.336 427.076 369.336C426.92 369.336 426.793 369.463 426.793 369.619C426.793 369.775 426.92 369.902 427.076 369.902Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M423.899 370.587C424.055 370.587 424.182 370.46 424.182 370.304C424.182 370.148 424.055 370.021 423.899 370.021C423.744 370.021 423.617 370.148 423.617 370.304C423.617 370.46 423.744 370.587 423.899 370.587Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M420.551 370.992C420.707 370.992 420.833 370.866 420.833 370.71C420.833 370.554 420.707 370.427 420.551 370.427C420.395 370.427 420.268 370.554 420.268 370.71C420.268 370.866 420.395 370.992 420.551 370.992Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M417.083 371.152C417.239 371.152 417.365 371.026 417.365 370.869C417.365 370.713 417.239 370.587 417.083 370.587C416.927 370.587 416.8 370.713 416.8 370.869C416.8 371.026 416.927 371.152 417.083 371.152Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M412.105 370.467C412.261 370.467 412.387 370.34 412.387 370.184C412.387 370.028 412.261 369.902 412.105 369.902C411.949 369.902 411.823 370.028 411.823 370.184C411.823 370.34 411.949 370.467 412.105 370.467Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M413.754 370.869C413.91 370.869 414.037 370.743 414.037 370.587C414.037 370.43 413.91 370.304 413.754 370.304C413.598 370.304 413.472 370.43 413.472 370.587C413.472 370.743 413.598 370.869 413.754 370.869Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M409.024 369.902C409.18 369.902 409.306 369.775 409.306 369.619C409.306 369.463 409.18 369.336 409.024 369.336C408.868 369.336 408.741 369.463 408.741 369.619C408.741 369.775 408.868 369.902 409.024 369.902Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M410.508 370.184C410.664 370.184 410.79 370.058 410.79 369.902C410.79 369.745 410.664 369.619 410.508 369.619C410.352 369.619 410.225 369.745 410.225 369.902C410.225 370.058 410.352 370.184 410.508 370.184Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M407.398 369.336C407.554 369.336 407.68 369.209 407.68 369.053C407.68 368.897 407.554 368.771 407.398 368.771C407.242 368.771 407.115 368.897 407.115 369.053C407.115 369.209 407.242 369.336 407.398 369.336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M425.454 370.304C425.61 370.304 425.736 370.177 425.736 370.021C425.736 369.865 425.61 369.738 425.454 369.738C425.298 369.738 425.171 369.865 425.171 370.021C425.171 370.177 425.298 370.304 425.454 370.304Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M422.177 370.869C422.333 370.869 422.459 370.743 422.459 370.587C422.459 370.43 422.333 370.304 422.177 370.304C422.021 370.304 421.894 370.43 421.894 370.587C421.894 370.743 422.021 370.869 422.177 370.869Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M418.621 371.152C418.777 371.152 418.903 371.026 418.903 370.869C418.903 370.713 418.777 370.587 418.621 370.587C418.465 370.587 418.338 370.713 418.338 370.869C418.338 371.026 418.465 371.152 418.621 371.152Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M415.386 371.152C415.542 371.152 415.668 371.026 415.668 370.869C415.668 370.713 415.542 370.587 415.386 370.587C415.23 370.587 415.104 370.713 415.104 370.869C415.104 371.026 415.23 371.152 415.386 371.152Z",
    fill: "black"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTyping, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/typing.0d228cbb.svg";
export { ForwardRef as ReactComponent };